<template>
    <div
        class="col-md-12 col-lg-12 mobile_pr_15 shipping_billing_address_col drawer_option"
    >
        <div class="white_box py_52 px_50 shipping_fl_left">
            <h1 class="heading1">2. Shipping & Billing Address</h1>
            <form
                method="post"
                @submit.prevent="addShippingAndPaymentDetail"
                data-vv-scope="shippingandpaymentform"
                class="f_fl_left shipping_address_form_custom address-shipping-popup"
            >
                <div class="row">
                    <div class="col-md-12">
                        <!-- create new radio button -->
                        <div class="shipping-options-section">
                            <h3 class="shipping-options-title">
                                Shipping Options
                            </h3>
                            <div class="shipping-options-radio-group">
                                <label class="shipping-option-label">
                                    <input
                                        type="radio"
                                        name="shipping_option"
                                        value="ship_to_address"
                                        v-model="shipping_option"
                                        checked
                                    />
                                    <span class="radio-text"
                                        >Ship To an Address</span
                                    >
                                </label>
                                <label class="shipping-option-label">
                                    <input type="radio" name="shipping_option" value="multiple"
                                        v-model="shipping_option" />
                                    <span class="radio-text">Ship to multiple Addresses</span>
                                </label>
                                <label class="shipping-option-label">
                                    <input
                                        type="radio"
                                        name="shipping_option"
                                        value="pickup_warehouse"
                                        v-model="shipping_option"
                                    />
                                    <span class="radio-text"
                                        >Pickup at warehouse</span
                                    >
                                </label>
                                <label class="shipping-option-label">
                                    <input
                                        type="radio"
                                        name="shipping_option"
                                        value="delivery"
                                        v-model="shipping_option"
                                    />
                                    <span class="radio-text">Delivery</span>
                                </label>
                                <img
                                    src="/maincss/images/info.svg"
                                    alt=" "
                                    class="info-icon d-none"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="display: none">
                    <div class="col-md-6">
                        <div class="form-group">
                            <input
                                type="text"
                                class="form-control"
                                id="Name"
                                name="Full Name"
                                placeholder="Enter Full Name"
                                v-model="order_data.fullname"
                                v-validate="'required'"
                            />
                            <label>Full name</label>
                            <span class="highlight"></span>
                            <small
                                class="form-text text-error text-left"
                                v-show="
                                    errors.has(
                                        'shippingandpaymentform.Full Name'
                                    )
                                "
                            >
                                {{
                                    errors.first(
                                        "shippingandpaymentform.Full Name"
                                    )
                                }}
                            </small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <input
                                type="text"
                                class="form-control"
                                id="Phone Number"
                                name="PhoneNumber"
                                placeholder="Enter Phone Number"
                                v-model="order_data.phone"
                                v-validate="'required|length:14'"
                                data-vv-as="Phone Number"
                                @input="acceptNumber"
                            />
                            <label>Phone number</label>
                            <span class="highlight"></span>
                            <small
                                class="form-text text-error text-left"
                                v-show="
                                    errors.has(
                                        'shippingandpaymentform.PhoneNumber'
                                    )
                                "
                            >
                                {{
                                    errors.first(
                                        "shippingandpaymentform.PhoneNumber"
                                    )
                                }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="form-group" style="display: none">
                    <input
                        type="text"
                        class="form-control"
                        id="Email"
                        name="Email"
                        placeholder="Enter Email"
                        v-model="order_data.email"
                        v-validate="'required|email'"
                    />
                    <label>Email address</label>
                    <span class="highlight"></span>
                    <small
                        class="form-text text-error text-left"
                        v-show="errors.has('shippingandpaymentform.Email')"
                    >
                        {{ errors.first("shippingandpaymentform.Email") }}
                    </small>
                </div>

                <div class="row" v-show="showShipToAddressControls">
                    <div class="col-md-12">
                        <h3 class="shipping-options-title mb_20">
                            Shipping Address
                        </h3>
                        <div class="form-check mt_16 pl-0">
                            <label class="checkbox_custom mb-0"
                                >Use the {{ CommonData.shipping_label }} as the
                                {{ CommonData.billing_label }}.
                                <input
                                    type="checkbox"
                                    :checked="!!order_data.sameaddress"
                                    @change="sameAddress($event)"
                                /><span
                                    class="checkmark"
                                ></span
                            ></label>
                        </div>
                    </div>
                </div>
                <div class="form-group mt_42 choose_address" v-show="showShipToAddressControls">
                    <div class="mt_20">
                        <label
                            style="margin-top: -10px"
                            class="select_option_label"
                            >Choose a {{ CommonData.shipping_label }}
                        </label>

                        <v-select
                            v-if="reloadShippingAddressSelect"
                            autocomplete="on"
                            label="address"
                            :reduce="(address) => address.id"
                            :options="all_billing_address"
                            :placeholder="shippingAddressPlaceholder"
                            name="shippingAddress"
                            data-vv-name="shippingAddress"
                            v-model="order_data.shippingaddressid"
                            v-validate="isShippingAddressRequired ? 'required' : ''"
                            :data-vv-as="CommonData.shipping_label"
                            @input="onChangeDeliveryAddress"
                        >
                        </v-select>
                        <small
                            class="form-text text-error text-left"
                            v-show="
                                errors.has(
                                    'shippingandpaymentform.shippingAddress'
                                )
                            "
                        >
                            {{
                                errors.first(
                                    "shippingandpaymentform.shippingAddress"
                                )
                            }}
                        </small>
                    </div>
                </div>

                <!-- Billing Address section - commented out as it shows below shipping address when checkbox is unchecked -->
                <!-- <div class="form-group mt_42" v-if="!order_data.sameaddress">
                    <div class="mt_20">
                        <label
                            style="margin-top: -10px"
                            class="select_option_label"
                            >Choose a {{ CommonData.billing_label }}
                        </label>

                        <v-select
                            autocomplete="on"
                            label="address"
                            :reduce="(address) => address.id"
                            :options="all_billing_address"
                            :placeholder="'Select Address'"
                            name="billingAddress"
                            v-model="order_data.billingaddressid"
                            v-validate="{ required: order_data.sameaddress }"
                            data-vv-as="Billing Address"
                            @input="onChangeBillingAddress"
                        >
                        </v-select>
                        <small
                            class="form-text text-error text-left"
                            v-show="
                                errors.has(
                                    'shippingandpaymentform.billingAddress'
                                )
                            "
                        >
                            {{
                                errors.first(
                                    "shippingandpaymentform.billingAddress"
                                )
                            }}
                        </small>
                    </div>
                </div> -->

                <div class="row shipping-box" style="display: none">
                    <div class="col-md-6" v-if="order_data.shippingaddressid">
                        <div class="delevery_block">
                            <h3>Your {{ CommonData.shipping_label }}</h3>

                            <span v-if="order_data.shippingaddress_label">
                                <b>Company Name:</b>
                                {{ order_data.shippingaddress_label }}<br />
                            </span>
                            <span
                                v-if="
                                    order_data.shipping_first_name ||
                                    order_data.shipping_last_name
                                "
                            >
                                <b>Recipient Name:</b>
                                {{
                                    order_data.shipping_first_name +
                                    " " +
                                    order_data.shipping_last_name
                                }}<br />
                            </span>
                            <span v-if="order_data.shippingaddress1">
                                {{ order_data.shippingaddress1 }}<br />
                            </span>
                            <span v-if="order_data.shippingaddress2">
                                {{ order_data.shippingaddress2 }}<br />
                            </span>

                            <span
                                v-if="
                                    order_data.shippingcity ||
                                    order_data.shippingaddressstate ||
                                    order_data.shippingaddresszip
                                "
                            >
                                {{
                                    [
                                        order_data.shippingcity,
                                        order_data.shippingaddressstate
                                            ? order_data.shippingaddressstate +
                                              (order_data.shippingaddresszip
                                                  ? " " +
                                                    order_data.shippingaddresszip
                                                  : "")
                                            : ""
                                    ]
                                        .filter(Boolean)
                                        .join(", ")
                                }}
                            </span>

                            <a
                                data-target="#deliveryAddressModal"
                                @click="storeTempData"
                                data-toggle="modal"
                                class="edit-button btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46"
                            >
                                <img
                                    class="mr_10"
                                    src="/maincss/images/pen.svg"
                                    alt=" "
                                />EDIT
                            </a>
                            <!-- DELIVERY ADDRESS FORM -->
                            <div
                                class="modal fade"
                                id="deliveryAddressModal"
                                tabindex="-1"
                                role="dialog"
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                                data-backdrop="static"
                            >
                                <div
                                    class="modal-dialog modal-dialog-centered new-address-popup customer-address"
                                    role="document"
                                >
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5
                                                class="modal-title"
                                                id="exampleModalLabel"
                                            >
                                                Edit
                                                {{ CommonData.shipping_label }}
                                            </h5>
                                            <button
                                                type="button"
                                                @click="restoreTempData"
                                                class="close"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <span aria-hidden="true"
                                                    >&times;</span
                                                >
                                            </button>
                                        </div>
                                        <form
                                            method="post"
                                            data-vv-scope="deliveryaddressform"
                                        >
                                            <div class="modal-body">
                                                <div class="two_input_one_row">
                                                    <div
                                                        class="form-group label-const"
                                                    >
                                                        <input
                                                            id="FirstName"
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter First Name"
                                                            v-model="
                                                                order_data.shipping_first_name
                                                            "
                                                            name="First Name"
                                                            v-validate="
                                                                'required'
                                                            "
                                                        />
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            >First Name
                                                        </label>
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'deliveryaddressform.First Name'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "deliveryaddressform.First Name"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>

                                                    <div
                                                        class="form-group label-const"
                                                    >
                                                        <input
                                                            id="LastName"
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Last Name"
                                                            v-model="
                                                                order_data.shipping_last_name
                                                            "
                                                            name="Last Name"
                                                            v-validate="
                                                                'required'
                                                            "
                                                        />
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            >Last Name
                                                        </label>
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'deliveryaddressform.Last Name'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "deliveryaddressform.Last Name"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                </div>
                                                <div class="two_input_one_row">
                                                    <div class="form-group">
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            class="add1"
                                                            >Company Name
                                                        </label>
                                                        <textarea
                                                            id="billingAddress1"
                                                            type="text"
                                                            class="form-control"
                                                            name="Address Label"
                                                            v-model="
                                                                order_data.shippingaddress_label
                                                            "
                                                            placeholder="Enter Address Label"
                                                            v-validate="
                                                                'required'
                                                            "
                                                            style="
                                                                padding: 0px 0px
                                                                    0px 5px !important;
                                                            "
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />

                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'deliveryaddressform.Address Label'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "deliveryaddressform.Address Label"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                    <div class="form-group">
                                                        <label
                                                            class="select_option_label bill_state"
                                                            >Address Type
                                                        </label>
                                                        <v-select
                                                            id="billingState"
                                                            autocomplete="off"
                                                            :options="
                                                                address_types
                                                            "
                                                            :placeholder="'Select Address Type'"
                                                            name="Address Type"
                                                            v-model="
                                                                order_data.shippingaddress_type
                                                            "
                                                            v-validate="
                                                                'required'
                                                            "
                                                            @input="
                                                                onChangeAddressType(
                                                                    order_data.shippingaddress_type,
                                                                    order_data.shippingaddressid
                                                                )
                                                            "
                                                        ></v-select>

                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                address_type_error
                                                            "
                                                            >{{
                                                                address_type_error
                                                            }}</small
                                                        >
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'deliveryaddressform.Address Type'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "deliveryaddressform.Address Type"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                </div>
                                                <div class="two_input_one_row">
                                                    <div class="form-group">
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            class="add1"
                                                            >Address 1
                                                            <img
                                                                v-if="
                                                                    order_data.shipping_address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <textarea
                                                            id="billingAddress1"
                                                            type="text"
                                                            class="form-control"
                                                            name="Address 1"
                                                            v-model="
                                                                order_data.shippingaddress1
                                                            "
                                                            v-validate="
                                                                'required'
                                                            "
                                                            placeholder="Enter Address 1"
                                                            style="
                                                                padding: 0px 0px
                                                                    0px 5px !important;
                                                            "
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'deliveryaddressform.Address 1'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "deliveryaddressform.Address 1"
                                                                )
                                                            }}
                                                        </small>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="
                                                                address1_suggestion
                                                            "
                                                            >Suggestion:
                                                            {{
                                                                address1_suggestion
                                                            }}</small
                                                        >
                                                    </div>
                                                    <div class="form-group">
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            class="add1"
                                                            >Address 2
                                                            <img
                                                                v-if="
                                                                    order_data.shipping_address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <textarea
                                                            id="billingAddress2"
                                                            type="text"
                                                            class="form-control"
                                                            name="Address 2"
                                                            v-model="
                                                                order_data.shippingaddress2
                                                            "
                                                            style="
                                                                padding: 0px 0px
                                                                    0px 5px !important;
                                                            "
                                                            placeholder="Enter Address 2"
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="address2_suggestion"
                                                            >Suggestion:
                                                            {{
                                                                address2_suggestion
                                                            }}</small
                                                        >
                                                    </div>
                                                </div>
                                                <div
                                                    class="two_input_one_row mt_20"
                                                >
                                                    <div
                                                        class="form-group label-const"
                                                    >
                                                        <input
                                                            id="billingCity"
                                                            type="text"
                                                            class="form-control"
                                                            v-model="
                                                                order_data.shippingcity
                                                            "
                                                            name="City"
                                                            v-validate="
                                                                'required'
                                                            "
                                                            placeholder="Enter City"
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            >City
                                                            <img
                                                                v-if="
                                                                    order_data.shipping_address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'deliveryaddressform.City'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "deliveryaddressform.City"
                                                                )
                                                            }}
                                                        </small>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="
                                                                city_suggestion
                                                            "
                                                            >Suggestion:
                                                            {{
                                                                city_suggestion
                                                            }}</small
                                                        >
                                                    </div>

                                                    <fieldset
                                                        v-show="
                                                            billingCountryUSA
                                                        "
                                                        class="form-group mt_ label-const"
                                                    >
                                                        <label
                                                            class="select_option_label bill_state"
                                                            >State
                                                            <img
                                                                v-if="
                                                                    order_data.shipping_address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <v-select
                                                            id="billingState"
                                                            autocomplete="off"
                                                            label="code"
                                                            :reduce="
                                                                (name) =>
                                                                    name.code
                                                            "
                                                            :options="
                                                                all_states
                                                            "
                                                            :placeholder="'Select State'"
                                                            name="State"
                                                            v-model="
                                                                order_data.shippingaddressstate
                                                            "
                                                            v-validate="
                                                                'required'
                                                            "
                                                            :class="'deliveryAddressModal'"
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        ></v-select>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'deliveryaddressform.State'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "deliveryaddressform.State"
                                                                )
                                                            }}
                                                        </small>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="
                                                                state_suggestion
                                                            "
                                                            >Suggestion:
                                                            {{
                                                                state_suggestion
                                                            }}</small
                                                        >
                                                    </fieldset>
                                                </div>
                                                <div
                                                    class="two_input_one_row mt_20"
                                                >
                                                    <div
                                                        class="form-group label-const"
                                                    >
                                                        <input
                                                            id="billingZip"
                                                            type="text"
                                                            class="form-control"
                                                            v-model="
                                                                order_data.shippingaddresszip
                                                            "
                                                            name="Zip Code"
                                                            v-validate="
                                                                'required'
                                                            "
                                                            placeholder="Enter Zipcode"
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            >Zip / Postal code
                                                            <img
                                                                v-if="
                                                                    order_data.shipping_address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'deliveryaddressform.Zip Code'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "deliveryaddressform.Zip Code"
                                                                )
                                                            }}
                                                        </small>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="
                                                                pincode_suggestion
                                                            "
                                                            >Suggestion:
                                                            {{
                                                                pincode_suggestion
                                                            }}</small
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <a
                                                    class="cancel-address btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46"
                                                    data-dismiss="modal"
                                                    @click="restoreTempData"
                                                >
                                                    CANCEL
                                                </a>
                                                <a
                                                    @click="
                                                        updateDeliveryAddress
                                                    "
                                                    class="save-address btn btn_orange btn btn_orange bg_primary_orange text_white py_18 px_64 ml_20"
                                                >
                                                    SAVE
                                                </a>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" v-if="order_data.billingaddressid">
                        <div class="delevery_block delivery">
                            <h3>Your {{ CommonData.billing_label }}</h3>

                            <span v-if="order_data.address_label"
                                ><b>Company Name:</b>
                                {{ order_data.address_label }}<br
                            /></span>
                            <span
                                v-if="
                                    order_data.billing_first_name ||
                                    order_data.billing_last_name
                                "
                                ><b>Recipient Name:</b>
                                {{
                                    order_data.billing_first_name +
                                    " " +
                                    order_data.billing_last_name
                                }}<br
                            /></span>
                            <span v-if="order_data.address1"
                                >{{ order_data.address1 }}<br
                            /></span>
                            <span v-if="order_data.address2"
                                >{{ order_data.address2 }}<br
                            /></span>
                            <span
                                v-if="
                                    order_data.city ||
                                    order_data.addressstate ||
                                    order_data.addresszip
                                "
                            >
                                {{
                                    [
                                        order_data.city,
                                        order_data.addressstate
                                            ? order_data.addressstate +
                                              (order_data.addresszip
                                                  ? " " + order_data.addresszip
                                                  : "")
                                            : ""
                                    ]
                                        .filter(Boolean)
                                        .join(", ")
                                }}
                            </span>

                            <a
                                data-target="#billingAddressModal"
                                @click="storeTempData"
                                data-toggle="modal"
                                class="edit-button btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46"
                            >
                                <img
                                    class="mr_10"
                                    src="/maincss/images/pen.svg"
                                    alt=" "
                                />EDIT
                            </a>
                            <!-- BILLING ADDRESS FORM -->
                            <div
                                class="modal fade"
                                id="billingAddressModal"
                                tabindex="-1"
                                role="dialog"
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                                data-backdrop="static"
                            >
                                <div
                                    class="modal-dialog modal-dialog-centered new-address-popup customer-address"
                                    role="document"
                                >
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5
                                                class="modal-title"
                                                id="exampleModalLabel"
                                            >
                                                Edit
                                                {{ CommonData.billing_label }}
                                            </h5>
                                            <button
                                                type="button"
                                                @click="restoreTempData"
                                                class="close"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <span aria-hidden="true"
                                                    >&times;</span
                                                >
                                            </button>
                                        </div>
                                        <form
                                            method="post"
                                            data-vv-scope="billingaddressform"
                                        >
                                            <div class="modal-body">
                                                <div class="two_input_one_row">
                                                    <div
                                                        class="form-group label-const"
                                                    >
                                                        <input
                                                            id="Address Title"
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Address Title (Optional)"
                                                            v-model="
                                                                order_data.billing_first_name
                                                            "
                                                            name="Address Title"
                                                            v-validate="
                                                                'required'
                                                            "
                                                        />
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            >Address Title
                                                            (Optional)
                                                        </label>
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.Address Title'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.Address Title"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>

                                                    <div
                                                        class="form-group label-const"
                                                    >
                                                        <input
                                                            id="LastName"
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Last Name"
                                                            v-model="
                                                                order_data.billing_last_name
                                                            "
                                                            name="Last Name"
                                                            v-validate="
                                                                'required'
                                                            "
                                                        />
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            >Last Name
                                                        </label>
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.Last Name'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.Last Name"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                </div>
                                                <div class="two_input_one_row">
                                                    <div class="form-group">
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            class="add1"
                                                            >Company Name
                                                        </label>
                                                        <textarea
                                                            id="billingAddress1"
                                                            type="text"
                                                            class="form-control"
                                                            name="Address Label"
                                                            v-model="
                                                                order_data.address_label
                                                            "
                                                            v-validate="
                                                                'required'
                                                            "
                                                            placeholder="Enter Address Label"
                                                            style="
                                                                padding: 0px 0px
                                                                    0px 5px !important;
                                                            "
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />

                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.Address Label'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.Address Label"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                    <div class="form-group">
                                                        <label
                                                            class="select_option_label bill_state"
                                                            >Address Type
                                                        </label>
                                                        <v-select
                                                            id="billingState"
                                                            autocomplete="off"
                                                            :options="
                                                                address_types
                                                            "
                                                            :placeholder="'Select Address Type'"
                                                            name="Address Type"
                                                            v-model="
                                                                order_data.address_type
                                                            "
                                                            v-validate="
                                                                'required'
                                                            "
                                                            @input="
                                                                onChangeAddressType(
                                                                    order_data.address_type,
                                                                    order_data.billingaddressid
                                                                )
                                                            "
                                                        ></v-select>

                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                address_type_error
                                                            "
                                                            >{{
                                                                address_type_error
                                                            }}</small
                                                        >

                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.Address Type'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.Address Type"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                </div>
                                                <div class="two_input_one_row">
                                                    <div class="form-group">
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            class="add1"
                                                            >Address 1
                                                            <img
                                                                v-if="
                                                                    order_data.address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <textarea
                                                            id="billingAddress1"
                                                            type="text"
                                                            class="form-control"
                                                            name="Address 1"
                                                            v-model="
                                                                order_data.address1
                                                            "
                                                            v-validate="
                                                                'required'
                                                            "
                                                            placeholder="Enter Address 1"
                                                            :disabled="
                                                                !newBillingAddress
                                                            "
                                                            style="
                                                                padding: 0px 0px
                                                                    0px 5px !important;
                                                            "
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.Address 1'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.Address 1"
                                                                )
                                                            }}
                                                        </small>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="
                                                                address1_suggestion
                                                            "
                                                            >Suggestion:
                                                            {{
                                                                address1_suggestion
                                                            }}</small
                                                        >
                                                    </div>
                                                    <div class="form-group">
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            class="add1"
                                                            >Address 2
                                                            <img
                                                                v-if="
                                                                    order_data.address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <textarea
                                                            id="billingAddress2"
                                                            type="text"
                                                            class="form-control"
                                                            name="Address 2"
                                                            v-model="
                                                                order_data.address2
                                                            "
                                                            :disabled="
                                                                !newBillingAddress
                                                            "
                                                            placeholder="Enter Address 2"
                                                            style="
                                                                padding: 0px 0px
                                                                    0px 5px !important;
                                                            "
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="address2_suggestion"
                                                            >Suggestion:
                                                            {{
                                                                address2_suggestion
                                                            }}</small
                                                        >
                                                    </div>
                                                </div>
                                                <div
                                                    class="two_input_one_row mt_20"
                                                >
                                                    <div
                                                        class="form-group label-const"
                                                    >
                                                        <input
                                                            id="billingCity"
                                                            type="text"
                                                            class="form-control"
                                                            v-model="
                                                                order_data.city
                                                            "
                                                            name="City"
                                                            placeholder="Enter City"
                                                            v-validate="
                                                                'required'
                                                            "
                                                            :disabled="
                                                                !newBillingAddress
                                                            "
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            >City
                                                            <img
                                                                v-if="
                                                                    order_data.address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.City'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.City"
                                                                )
                                                            }}
                                                        </small>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="
                                                                city_suggestion
                                                            "
                                                            >Suggestion:
                                                            {{
                                                                city_suggestion
                                                            }}</small
                                                        >
                                                    </div>
                                                    <div
                                                        class="form-group"
                                                        v-show="
                                                            !billingCountryUSA
                                                        "
                                                    >
                                                        <input
                                                            id="billingState"
                                                            type="text"
                                                            class="form-control"
                                                            v-model="
                                                                order_data.addressstate
                                                            "
                                                            name="State"
                                                            v-validate="
                                                                'required'
                                                            "
                                                            :disabled="
                                                                !newBillingAddress
                                                            "
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            >State
                                                            <img
                                                                v-if="
                                                                    order_data.address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.State'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.State"
                                                                )
                                                            }}
                                                        </small>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="
                                                                state_suggestion
                                                            "
                                                            >Suggestion:
                                                            {{
                                                                state_suggestion
                                                            }}</small
                                                        >
                                                    </div>
                                                    <fieldset
                                                        v-show="
                                                            billingCountryUSA
                                                        "
                                                        class="form-group mt_ label-const"
                                                    >
                                                        <label
                                                            class="select_option_label bill_state"
                                                            >State
                                                            <img
                                                                v-if="
                                                                    order_data.address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <v-select
                                                            id="billingState"
                                                            autocomplete="off"
                                                            label="code"
                                                            :reduce="
                                                                (name) =>
                                                                    name.code
                                                            "
                                                            :options="
                                                                all_states
                                                            "
                                                            :placeholder="'Select State'"
                                                            name="State"
                                                            v-model="
                                                                order_data.addressstate
                                                            "
                                                            v-validate="
                                                                'required'
                                                            "
                                                            :class="
                                                                !newBillingAddress
                                                                    ? 'removeDisableIcon'
                                                                    : ''
                                                            "
                                                            :disabled="
                                                                !newBillingAddress
                                                            "
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        ></v-select>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.State'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.State"
                                                                )
                                                            }}
                                                        </small>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="
                                                                state_suggestion
                                                            "
                                                            >Suggestion:
                                                            {{
                                                                state_suggestion
                                                            }}</small
                                                        >
                                                    </fieldset>
                                                </div>
                                                <div
                                                    class="two_input_one_row mt_20"
                                                >
                                                    <div
                                                        class="form-group label-const"
                                                    >
                                                        <input
                                                            id="billingZip"
                                                            type="text"
                                                            class="form-control"
                                                            v-model="
                                                                order_data.addresszip
                                                            "
                                                            name="Zip Code"
                                                            v-validate="
                                                                'required'
                                                            "
                                                            placeholder="Enter Zipcode"
                                                            :disabled="
                                                                !newBillingAddress
                                                            "
                                                            @input="
                                                                resetShippingProvider
                                                            "
                                                        />
                                                        <label
                                                            style="
                                                                top: -5px;
                                                                font-size: 14px;
                                                                color: #000;
                                                            "
                                                            >Zip / Postal code
                                                            <img
                                                                v-if="
                                                                    order_data.address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.Zip Code'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.Zip Code"
                                                                )
                                                            }}
                                                        </small>
                                                        <small
                                                            class="form-text text-error text-left font-weight-bold"
                                                            v-if="
                                                                pincode_suggestion
                                                            "
                                                            >Suggestion:
                                                            {{
                                                                pincode_suggestion
                                                            }}</small
                                                        >
                                                    </div>
                                                    <fieldset
                                                        class="form-group"
                                                        v-show="
                                                            internationalShipping
                                                        "
                                                    >
                                                        <label
                                                            style="
                                                                margin-top: -10px;
                                                            "
                                                            class="select_option_label"
                                                            >Country
                                                            <img
                                                                v-if="
                                                                    order_data.address_verified ===
                                                                    1
                                                                "
                                                                src="/maincss/images/success_1.svg"
                                                                alt=" "
                                                            />
                                                        </label>
                                                        <v-select
                                                            id="billingCountry"
                                                            autocomplete="off"
                                                            label="name"
                                                            :reduce="
                                                                (name) =>
                                                                    name.code
                                                            "
                                                            :options="
                                                                all_countries
                                                            "
                                                            :placeholder="'Select Country'"
                                                            name="Country"
                                                            v-model="
                                                                order_data.billingcountry
                                                            "
                                                            @input="
                                                                isBillingCountryUSA(
                                                                    $event
                                                                );
                                                                resetShippingProvider();
                                                            "
                                                            :disabled="
                                                                !internationalShipping
                                                            "
                                                        ></v-select>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'billingaddressform.Country'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "billingaddressform.Country"
                                                                )
                                                            }}
                                                        </small>
                                                    </fieldset>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <a
                                                    class="cancel-address btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46"
                                                    data-dismiss="modal"
                                                    @click="restoreTempData"
                                                >
                                                    CANCEL
                                                </a>
                                                <a
                                                    @click="
                                                        updateBillingAddress
                                                    "
                                                    class="save-address btn btn_orange btn btn_orange bg_primary_orange text_white py_18 px_64 ml_20"
                                                >
                                                    SAVE
                                                </a>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group mt_0" v-show="showShipToAddressControls">
                    <span class="highlight"></span>
                    <div class="address-btn">
                        <a href="javascript:void(0);"
                            @click="activeAddressType = 'shipping'; showInlineAddressForm = true; resetNewAddressForm()"
                            class="text_primary_blue btn_link mt_8 d-block font_size_14 link">
                            {{ showInlineAddressForm ? '' : '+ Add New Address' }}
                        </a>
                    </div>
                </div>
              
                <!-- Shipping Add New Address (Standard) -->
                <div class="address-form-section mb-4 mt-3 address-new-form-section" v-if="showShipToAddressControls && showInlineAddressForm && activeAddressType === 'shipping'"
                    >
                    <h3 style="font-size: 16px; font-weight: 700;">Add New Address</h3>

                    <form data-vv-scope="newaddressform">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group address_type font_change">
                                    <label class="select_option_label"
                                        style=" margin-bottom:8px;">Address Type<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <v-select id="billingState" :options="address_types"
                                        :placeholder="'Select Address Type'" name="Address Type"
                                        v-model="newAddress.address_type" v-validate="'required'"
                                        @input="onChangeAddressType(newAddress.address_type)"></v-select>
                                    <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Address Type')">
                                        {{ errors.first("newaddressform.Address Type") }}
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group label-const font_change">
                                    <label>Address Title
                                        (Optional)</label>
                                    <input type="text" class="form-control" placeholder="Enter Address Title"
                                        v-model="newAddress.address_title" name="Address Title" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group label-const font_change">
                                    <label>Company
                                        Name (Optional)</label>
                                    <textarea class="form-control" placeholder="Enter Company Name"
                                        v-model="newAddress.address_label" name="Company Name"
                                        style="height:40px !important;"></textarea>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group label-const font_change">
                                    <label>First
                                        Name<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="text" class="form-control" v-model="newAddress.first_name"
                                        name="First Name" v-validate="'required'" placeholder="Enter First Name">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.First Name')">
                                        {{ errors.first("newaddressform.First Name") }}
                                    </small>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group label-const font_change">
                                    <label>Last
                                        Name<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="text" class="form-control" v-model="newAddress.last_name"
                                        name="Last Name" v-validate="'required'" placeholder="Enter Last Name">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Last Name')">
                                        {{ errors.first("newaddressform.Last Name") }}
                                    </small>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group label-const font_change">
                                    <label>Address
                                        1<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <textarea class="form-control" v-model="newAddress.address1" name="Address 1"
                                        v-validate="'required'" placeholder="Enter Address 1" rows="2"
                                        style="height:auto !important;"></textarea>
                                    <small class="text-info" v-if="newAddress.address1_suggestion">Suggestion: {{
                                        newAddress.address1_suggestion }}</small>
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Address 1')">
                                        {{ errors.first("newaddressform.Address 1") }}
                                    </small>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group label-const font_change">
                                    <label>Address 2</label>
                                    <textarea
                                        class="form-control"
                                        v-model="newAddress.address2"
                                        placeholder="Enter Address 2"
                                        rows="2"
                                        style="height:auto !important;"
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group font_change"><label
                                       >City<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="text" class="form-control" v-model="newAddress.city" name="City"
                                        v-validate="'required'" placeholder="Enter City">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.City')">
                                        {{ errors.first("newaddressform.City") }}
                                    </small>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group font_change"><label class="select_option_label"
                                        style=" margin-bottom:8px;">State<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <v-select label="code" :reduce="s => s.code" :options="all_states"
                                        v-model="newAddress.state" name="State" v-validate="'required'"
                                        placeholder="Select State"></v-select>
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.State')">
                                        {{ errors.first("newaddressform.State") }}
                                    </small>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group font_change"><label
                                       >Zip<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="text" class="form-control" v-model="newAddress.pincode" name="Zip Code"
                                        v-validate="'required'" placeholder="Enter Zip Code">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Zip Code')">
                                        {{ errors.first("newaddressform.Zip Code") }}
                                    </small>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group font_change"><label class="select_option_label"
                                        style=" margin-bottom:8px;">Country</label>
                                    <v-select label="name" :reduce="c => c.code" :options="all_countries"
                                        v-model="newAddress.country" placeholder="Select Country"></v-select>
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Country')">
                                        {{ errors.first("newaddressform.Country") }}
                                    </small>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group label-const font_change">
                                    <label>Phone</label>
                                    <input type="text" class="form-control" v-model="newAddress.phone" name="Phone"
                                      placeholder="Enter Phone">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group label-const font_change">
                                    <label>Email<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="email" class="form-control" v-model="newAddress.email" name="Email"
                                        v-validate="'required|email'" placeholder="Enter Email">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Email')">
                                        {{ errors.first("newaddressform.Email") }}
                                    </small>
                            </div>
                        </div>

                        <div class="form-actions mt-4 d-flex justify-content-end" style="gap:15px;">
                            <button type="button" class="btn btn_outline_primary border_primary_blue shipping_cancel"
                                @click="showInlineAddressForm = false">CANCEL</button>
                            <button type="button" class="btn btn_orange bg_primary_orange text_white shipping_save"
                                @click="addNewAddress">SAVE ADDRESS</button>
                        </div>
                    </form>
                </div>
                <!-- Billing Address (mt_32 only when ship-to block above is visible) -->
                <div class="row" :class="{ mt_32: showShipToAddressControls }">
                    <div class="col-md-12">
                        <h3 class="shipping-options-title mb_20 billing_address_title">
                            Billing Address
                        </h3>
                    </div>
                </div>
                <div class="form-group mt_0 choose_address">
                    <div class="mt_0">
                        <label
                            class="select_option_label billing_label"
                            >Choose a {{ CommonData.billing_label }}
                        </label>

                        <v-select
                            v-if="reloadDeliveryAddressInput"
                            autocomplete="on"
                            label="address"
                            :reduce="(address) => address.id"
                            :options="all_billing_address"
                            :placeholder="'Select Address'"
                            name="billingAddress"
                            data-vv-name="billingAddress"
                            v-model="order_data.billingaddressid"
                            v-validate="'required'"
                            :data-vv-as="CommonData.billing_label"
                            @input="onChangeBillingAddress"
                            :disabled="order_data.sameaddress"
                        >
                        </v-select>
                        <small
                            class="form-text text-error text-left"
                            v-show="
                                errors.has(
                                    'shippingandpaymentform.billingAddress'
                                )
                            "
                        >
                            {{
                                errors.first(
                                    "shippingandpaymentform.billingAddress"
                                )
                            }}
                        </small>
                    </div>
                    <a href="javascript:void(0);"
                        @click="activeAddressType = 'billing'; showInlineAddressForm = true; resetNewAddressForm()"
                        class="text_primary_blue btn_link mt_8 d-block font_size_14 link">
                        {{ showInlineAddressForm ? '' : '+ Add New Address' }}
                    </a>
                    <!-- Billing Add New Address (Standard) -->
                    <div class="address-form-section mb-4 mt-3 address-new-form-section" v-if="showInlineAddressForm && activeAddressType === 'billing'"
                    >
                    <h3 style="font-size: 16px; font-weight: 700;">Add New Address</h3>

                    <form data-vv-scope="newaddressform">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group address_type font_change">
                                    <label class="select_option_label"
                                        style=" margin-bottom:8px;">Address Type<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <v-select id="billingState" :options="address_types"
                                        :placeholder="'Select Address Type'" name="Address Type"
                                        v-model="newAddress.address_type" v-validate="'required'"
                                        @input="onChangeAddressType(newAddress.address_type)"></v-select>
                                    <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Address Type')">
                                        {{ errors.first("newaddressform.Address Type") }}
                                    </small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group label-const font_change">
                                    <label>Address Title
                                        (Optional)</label>
                                    <input type="text" class="form-control" placeholder="Enter Address Title"
                                        v-model="newAddress.address_title" name="Address Title" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group label-const font_change">
                                    <label>Company
                                        Name (Optional)</label>
                                    <textarea class="form-control" placeholder="Enter Company Name"
                                        v-model="newAddress.address_label" name="Company Name"
                                        style="height:40px !important;"></textarea>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group label-const font_change">
                                    <label>First
                                        Name<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="text" class="form-control" v-model="newAddress.first_name"
                                        name="First Name" v-validate="'required'" placeholder="Enter First Name">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.First Name')">
                                        {{ errors.first("newaddressform.First Name") }}
                                    </small>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group label-const font_change">
                                    <label>Last
                                        Name<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="text" class="form-control" v-model="newAddress.last_name"
                                        name="Last Name" v-validate="'required'" placeholder="Enter Last Name">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Last Name')">
                                        {{ errors.first("newaddressform.Last Name") }}
                                    </small>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group label-const font_change">
                                    <label>Address
                                        1<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <textarea class="form-control" v-model="newAddress.address1" name="Address 1"
                                        v-validate="'required'" placeholder="Enter Address 1" rows="2"
                                        style="height:auto !important;"></textarea>
                                    <small class="text-info" v-if="newAddress.address1_suggestion">Suggestion: {{
                                        newAddress.address1_suggestion }}</small>
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Address 1')">
                                        {{ errors.first("newaddressform.Address 1") }}
                                    </small>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group label-const font_change">
                                    <label>Address 2</label>
                                    <textarea
                                        class="form-control"
                                        v-model="newAddress.address2"
                                        placeholder="Enter Address 2"
                                        rows="2"
                                        style="height:auto !important;"
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group font_change"><label
                                       >City<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="text" class="form-control" v-model="newAddress.city" name="City"
                                        v-validate="'required'" placeholder="Enter City">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.City')">
                                        {{ errors.first("newaddressform.City") }}
                                    </small>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group font_change"><label class="select_option_label"
                                        style=" margin-bottom:8px;">State<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <v-select label="code" :reduce="s => s.code" :options="all_states"
                                        v-model="newAddress.state" name="State" v-validate="'required'"
                                        placeholder="Select State"></v-select>
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.State')">
                                        {{ errors.first("newaddressform.State") }}
                                    </small>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group font_change"><label
                                       >Zip<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="text" class="form-control" v-model="newAddress.pincode" name="Zip Code"
                                        v-validate="'required'" placeholder="Enter Zip Code">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Zip Code')">
                                        {{ errors.first("newaddressform.Zip Code") }}
                                    </small>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group font_change"><label class="select_option_label"
                                        style=" margin-bottom:8px;">Country</label>
                                    <v-select label="name" :reduce="c => c.code" :options="all_countries"
                                        v-model="newAddress.country" placeholder="Select Country"></v-select>
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Country')">
                                        {{ errors.first("newaddressform.Country") }}
                                    </small>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group label-const font_change">
                                    <label>Phone</label>
                                    <input type="text" class="form-control" v-model="newAddress.phone" name="Phone"
                                      placeholder="Enter Phone">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group label-const font_change">
                                    <label>Email<span class="label-required-mark" aria-hidden="true">*</span></label>
                                    <input type="email" class="form-control" v-model="newAddress.email" name="Email"
                                        v-validate="'required|email'" placeholder="Enter Email">
                                </div>
                                <small class="form-text text-error text-left"
                                        v-show="errors.has('newaddressform.Email')">
                                        {{ errors.first("newaddressform.Email") }}
                                    </small>
                            </div>
                        </div>

                        <div class="form-actions mt-4 d-flex justify-content-end" style="gap:15px;">
                            <button type="button" class="btn btn_outline_primary border_primary_blue shipping_cancel"
                                @click="showInlineAddressForm = false">CANCEL</button>
                            <button type="button" class="btn btn_orange bg_primary_orange text_white shipping_save"
                                @click="addNewAddress">SAVE ADDRESS</button>
                        </div>
                    </form>
                </div>

                </div>
                <div class="form-group comment_label_block">
                     <label class="comment-label"
                        >If you would like to add a comment about your order,
                        please write it in the field below.</label
                    >
                    <textarea
                        class="comment-text-area"
                        v-model="order_data.comment"
                    ></textarea>
                   
                    <span class="highlight"></span>
                </div>

                <!-- Shipping Methods -->
                <div class="payment_method mt_14" style="display: none">
                    <div class="two_input_one_row mt_22">
                        <div class="shiping_carrier">
                            <h1 class="font_size_28 mb_0">Shipping Carriers</h1>
                            <div
                                class="d-flex justify-content-xlg-between mt_20 shipping_carrier_radio_box"
                            >
                                <p
                                    class="mb-0 mx_6"
                                    v-for="(carriers, indx) in shippingCarriers"
                                    :key="indx"
                                >
                                    <input
                                        type="radio"
                                        :id="carriers.id"
                                        name="shippingproviderid"
                                        :value="carriers.id"
                                        class="form-control"
                                        v-model="order_data.shippingproviderid"
                                        v-validate="'required'"
                                        data-vv-as="Shipping Carrier"
                                        @change="
                                            getShippingProviderImage(
                                                carriers.id,
                                                carriers.shpping_provider
                                            )
                                        "
                                    />
                                    <label
                                        :for="carriers.id"
                                        class="m-0 right_radio_btn_fedx"
                                    >
                                        <img
                                            :src="
                                                carriers.image_url
                                                    ? carriers.image_url
                                                    : 'https://cdn.logo.com/hotlink-ok/logo-social.png'
                                            "
                                            alt=" "
                                        />
                                    </label>
                                </p>
                            </div>
                            <small
                                class="form-text text-error text-left"
                                v-show="
                                    errors.has(
                                        'shippingandpaymentform.shippingproviderid'
                                    )
                                "
                            >
                                {{
                                    errors.first(
                                        "shippingandpaymentform.shippingproviderid"
                                    )
                                }}
                            </small>
                        </div>

                        <div class="shiping_methods">
                            <h1 class="font_size_28 mb_0">Shipping Methods</h1>
                            <div class="position-relative shipping_method_drop">
                                <label class="select_option_label"
                                    >Select method</label
                                >
                                <v-select
                                    label="serviceName"
                                    :reduce="
                                        (shipping_method) => shipping_method
                                    "
                                    :options="shipping_methods"
                                    :placeholder="'Select Shipping Method'"
                                    name="Shipping_Methods"
                                    v-model="selected_shiping_method"
                                    v-validate="'required'"
                                    data-vv-as="Shipping Methods"
                                    @input="calculate_shipping"
                                >
                                    <!-- eslint-disable -->
                                    <template
                                        #selected-option-container="{
                                            option,
                                            deselect,
                                            multiple,
                                            disabled
                                        }"
                                    >
                                        <span class="vs__selected">
                                            {{ option.serviceName }} ({{
                                                icPriceFormat(option.total)
                                            }})
                                        </span>
                                    </template>
                                    <!-- eslint-enable -->
                                    <template v-slot:option="option">
                                        {{ option.serviceName }} ({{
                                            icPriceFormat(option.total)
                                        }})
                                    </template>
                                </v-select>
                                <small
                                    class="form-text text-error text-left"
                                    v-show="
                                        errors.has(
                                            'shippingandpaymentform.Shipping_Methods'
                                        )
                                    "
                                >
                                    {{
                                        errors.first(
                                            "shippingandpaymentform.Shipping_Methods"
                                        )
                                    }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display: none">
                    <p class="font_size_16 text_light_grey mt_30">
                        By clicking the button, you agree to the
                        <a
                            data-toggle="modal"
                            data-target="#termsAndConditions"
                            data-dismiss="modal"
                            class="opacity_60"
                        >
                            Terms & Conditions
                        </a>
                    </p>
                </div>

                <div class="" style="display: none">
                    <button
                        :disabled="
                            (!email_confirmation &&
                                order_data.address_verified == 1) == false
                        "
                        type="submit"
                        class="btn btn_orange bg_primary_orange text_white d-block py_22"
                        style="width: 100%; max-width: 100%"
                    >
                        Payment & Shipment
                    </button>
                </div>
                <div class="fixed_b_order_total_block">
                    <div class="order-total-container">
                        <div class="left-section">
                            <button
                                type="button"
                                class="btn btn-back"
                                @click="$router.go(-1)"
                            >
                                BACK
                            </button>
                        </div>

                        <div class="right-section">
                            <div
                                class="order-total-info"
                                @click="showOrderDrawer = true"
                            >
                                <span class="chevron-icon">
                                    <svg
                                        width="12"
                                        height="8"
                                        viewBox="0 0 12 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1 1L6 6L11 1"
                                            stroke="#808080"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </span>
                                <span class="order-total-label" 
                                    >Order Total</span
                                >
                                <span class="order-total-amount">
                                    {{
                                        $parent.order_data &&
                                        $parent.order_data.grand_total
                                            ? icPriceFormat(
                                                  $parent.order_data.grand_total
                                              )
                                            : "$0.00"
                                    }}
                                </span>
                            </div>

                            <button type="submit" class="btn btn-next">
                                NEXT
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <!-- Order Summary Drawer -->
        <!-- <transition name="drawer-overlay">
            <div v-if="showOrderDrawer" class="order-drawer-overlay" @click="showOrderDrawer = false"></div>
        </transition> -->

        <transition name="drawer-slide">
            <div v-if="showOrderDrawer" class="order-summary-drawer">
                <div class="drawer-header">
                    <h3 class="drawer-title">Cart Summary</h3>
                    <button type="button" class="drawer-edit-btn">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_6501_108001)">
                                <g clip-path="url(#clip1_6501_108001)">
                                    <g clip-path="url(#clip2_6501_108001)">
                                        <path
                                            d="M17.7002 0.801351C17.1838 0.285714 16.4839 -0.00390625 15.7542 -0.00390625C15.0244 -0.00390625 14.3245 0.285714 13.8082 0.801351L12.8342 1.78135L2.46815 12.1464L2.44615 12.1684C2.44115 12.1734 2.44115 12.1794 2.43515 12.1794C2.42415 12.1964 2.40715 12.2124 2.39715 12.2284C2.38715 12.2444 2.39115 12.2344 2.39115 12.2394C2.39115 12.2444 2.37515 12.2674 2.36315 12.2834C2.35115 12.2994 2.35815 12.2944 2.35215 12.3004C2.34615 12.3063 2.34115 12.3284 2.33515 12.3444C2.32915 12.3604 2.33015 12.3494 2.33015 12.3554L0.029152 19.2754C-0.00383067 19.3718 -0.00894095 19.4756 0.014408 19.5749C0.0377569 19.6741 0.0886183 19.7647 0.161152 19.8364C0.265235 19.9392 0.405801 19.9968 0.552152 19.9964C0.611826 19.9951 0.671049 19.9857 0.728152 19.9684L7.64215 17.6614C7.64715 17.6614 7.64715 17.6614 7.65315 17.6564C7.6704 17.6513 7.68688 17.6439 7.70215 17.6343C7.70627 17.6339 7.71013 17.6322 7.71315 17.6294C7.72915 17.6184 7.75115 17.6073 7.76815 17.5963C7.78515 17.5854 7.80115 17.5694 7.81815 17.5584C7.83515 17.5474 7.82915 17.5523 7.82915 17.5473C7.82915 17.5424 7.84615 17.5364 7.85115 17.5254L19.2002 6.17935C19.7158 5.66299 20.0054 4.96308 20.0054 4.23335C20.0054 3.50362 19.7158 2.80371 19.2002 2.28735L17.7002 0.801351ZM7.46615 16.3684L3.63515 12.5374L13.2242 2.94835L17.0552 6.77935L7.46615 16.3684ZM3.10015 13.5554L6.44715 16.9024L1.41615 18.5753L3.10015 13.5554ZM18.4212 5.40835L17.8372 5.99735L14.0062 2.16635L14.5952 1.57735C14.9047 1.26799 15.3245 1.09422 15.7622 1.09422C16.1998 1.09422 16.6196 1.26799 16.9292 1.57735L18.4292 3.07735C18.7351 3.38863 18.9058 3.80805 18.9043 4.24449C18.9028 4.68094 18.7292 5.09917 18.4212 5.40835Z"
                                            fill="black"
                                        />
                                    </g>
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_6501_108001">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                                <clipPath id="clip1_6501_108001">
                                    <rect
                                        width="20"
                                        height="19.99"
                                        fill="white"
                                    />
                                </clipPath>
                                <clipPath id="clip2_6501_108001">
                                    <rect
                                        width="20.002"
                                        height="20"
                                        fill="white"
                                        transform="translate(0 -0.00390625)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                    <button
                        type="button"
                        class="drawer-close-btn"
                        @click="showOrderDrawer = false"
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect width="24" height="24" rx="12" fill="white" />
                            <path
                                d="M7 7L17 17M7 17L17 7"
                                stroke="#606060"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                </div>

                <div class="drawer-content">
                    <div class="order_prod_list">
                        <div class="order_prod_item">
                            <div class="order_prod_item_img_flex">
                                <img
                                    src="/maincss/images/product_img.png"
                                    alt="product"
                                    class="order_prod_item_img"
                                />
                                <div class="order_prod_item_details">
                                    <h3 class="order_prod_item_title">
                                        Golf & Travel Shoe Bag
                                    </h3>
                                    <p class="order_prod_item_category">Bag</p>
                                    <p class="order_prod_item_OSFA">OSFA: 50</p>
                                </div>
                            </div>
                            <p class="order_prod_item_price">$752.50</p>
                        </div>
                    </div>
                    <div class="order-breakdown-section">
                        <div class="breakdown-item">
                            <span class="breakdown-label">Sub Total</span>
                            <span class="breakdown-value">
                                {{
                                    $parent.order_data &&
                                    $parent.order_data.order_price
                                        ? icPriceFormat(
                                              $parent.order_data.order_price
                                          )
                                        : "$0.00"
                                }}
                            </span>
                        </div>

                        <div
                            class="breakdown-item"
                            v-if="
                                $parent.order_data &&
                                $parent.order_data.total_non_standard_fees > 0
                            "
                        >
                            <span class="breakdown-label">Fees</span>
                            <span class="breakdown-value">
                                {{
                                    icPriceFormat(
                                        $parent.order_data
                                            .total_non_standard_fees
                                    )
                                }}
                            </span>
                        </div>

                        <div class="breakdown-item">
                            <span class="breakdown-label">Sales Tax</span>
                            <span class="breakdown-value">
                                {{
                                    $parent.order_data &&
                                    $parent.order_data.sales_tax
                                        ? icPriceFormat(
                                              $parent.order_data.sales_tax
                                          )
                                        : "$0.00"
                                }}
                            </span>
                        </div>

                        <div class="breakdown-item">
                            <span class="breakdown-label">
                                Shipping
                                <svg
                                    class="info-icon"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="8"
                                        cy="8"
                                        r="7"
                                        stroke="#999"
                                        stroke-width="1.5"
                                    />
                                    <text
                                        x="8"
                                        y="11"
                                        text-anchor="middle"
                                        font-size="10"
                                        fill="#999"
                                        font-weight="600"
                                    >
                                        i
                                    </text>
                                </svg>
                            </span>
                            <span class="breakdown-value">
                                {{
                                    $parent.order_data &&
                                    $parent.order_data.shipping_cost
                                        ? icPriceFormat(
                                              $parent.order_data.shipping_cost
                                          )
                                        : "$0.00"
                                }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <!-- TERMS AND CONDITIONS MODEL -->
        <div
            class="modal login-form-popup fade h-auto"
            id="termsAndConditions"
            tabindex="-1"
            aria-labelledby="termsAndConditions"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div
                        class="modal-body"
                        style="overflow-y: auto; height: 100vh"
                    >
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close-termsAndConditions"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                        <TermsAndConditions :onCheckoutPage="onCheckoutPage" />
                    </div>
                </div>
            </div>
        </div>

        <!-- ADDRESS MODEL -->
        <div
            class="modal login-form-popup fade h-auto"
            id="address"
            tabindex="-1"
            aria-labelledby="address"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close-address"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                        <div class="address-form">
                            <h3>Add New Address</h3>

                            <form
                                method="post"
                                @submit.prevent="onSubmitAddress"
                                data-vv-scope="addressform"
                                :key="'addressform'"
                            >
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="address1"
                                        name="address1"
                                        v-model="address_data.address1"
                                        v-validate="'required'"
                                    />
                                    <label>Address 1</label>
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has('addressform.address1')
                                        "
                                    >
                                        {{
                                            errors.first("addressform.address1")
                                        }}
                                    </small>
                                </div>
                                <div class="form-group custom_group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="address2"
                                        name="address2"
                                        v-model="address_data.address2"
                                    />
                                    <label>Address 2</label>
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                </div>
                                <div class="">
                                    <!-- <label class="label-control2">State</label> -->
                                    <fieldset
                                        class="form-group mb-0 margin_form_0"
                                    >
                                        <v-select
                                            autocomplete="off"
                                            label="code"
                                            :reduce="(name) => name.code"
                                            :options="all_states"
                                            :placeholder="'Select State'"
                                            name="state"
                                            v-model="address_data.state"
                                            v-validate="'required'"
                                            data-vv-as="State"
                                        ></v-select>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has('addressform.state')
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "addressform.state"
                                                )
                                            }}
                                        </small>
                                    </fieldset>
                                </div>
                                <div class="form-group custom_group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="city"
                                        name="city"
                                        v-model="address_data.city"
                                        v-validate="'required'"
                                    />
                                    <label>City</label>
                                    <span class="highlight"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="errors.has('addressform.city')"
                                    >
                                        {{ errors.first("addressform.city") }}
                                    </small>
                                </div>

                                <div class="form-group custom_group">
                                    <input
                                        type="text"
                                        name="pincode"
                                        class="form-control"
                                        id="zipcode"
                                        v-validate="'required'"
                                        v-model="address_data.pincode"
                                    />
                                    <label>Zip / Postal code</label>
                                    <span class="highlight"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has('addressform.pincode')
                                        "
                                    >
                                        {{
                                            errors.first("addressform.pincode")
                                        }}
                                    </small>
                                </div>

                                <button
                                    type="submit"
                                    class="btn btn_orange bg_primary_orange text_white w-100 mt_34 mb_32 btn_h60"
                                >
                                    Add
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import ApiService from "@/common/api.service";
import TermsAndConditions from "@/views/frontend/footer_pages/TermsConditions";
import CommonData from "@/common/common.data";

export default {
    name: "ShippingPayment",
    directives: { mask },
    components: { TermsAndConditions },
    data() {
        return {
            // placingOrder:false,
            showInlineAddressForm: false,
            activeAddressType: '',
            email_confirmation: false,
            masklength: "",
            base_url: window.location.origin,
            isBusy: false,
            onCheckoutPage: true,
            newBillingAddress: true, //If Add New Address clicked for Billing Address
            newShippingAddress: true, //If Add New Address clicked for Shipping Address
            currentYear: new Date().getFullYear().toString().substr(-2), //For Card Expiry Year
            presentMonth: new Date().getMonth() + 1, //For Card Expiry Month
            changedYear: "",
            newBillingAddressCreated: false,
            newShippingAddressCreated: false,
            newlyCreatedBillingAddress: "",
            newlyCreatedShippingAddress: "",
            all_states: [],
            all_countries: [],
            address_data: {
                address1: "",
                address2: "",
                state: "",
                city: "",
                country: "",
                pincode: ""
            },
            shipping_address_data: {
                address1: "",
                address2: "",
                state: "",
                city: "",
                country: "",
                pincode: ""
            },
            all_billing_address: [],
            all_shipping_address: [],
            shipping_option: "ship_to_address",
            addresses: [],
            shippingCarriers: [],
            billingCountryUSA: true,
            shippingCountryUSA: true,
            internationalShipping: false,
            order_data: {
                fullname: "",
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                billingaddressid: "",
                shippingaddressid: "",
                sameaddress: true,
                billing_first_name: "",
                billing_last_name: "",
                address1: "",
                address2: "",
                city: "",
                addresszip: "",
                addressstate: "",
                address_type: "",
                address_label: "",
                address_title: "",
                address_verified: 0,
                billingcountry: "US",
                full_address: "",
                shippingphone: "",
                shippingaddress1: "",
                shippingaddress2: "",
                shippingcity: "",
                shippingaddresszip: "",
                shippingaddressstate: "",
                shippingcountry: "US",
                shipping_full_address: "",
                shippingproviderid: "",
                shipping_provider_name: "",
                shipping_address_verified: 0,
                shippingmethod: "Ground as",
                shippingproviderimage: "",
                shippingaddress_label: "",
                shippingaddress_title: "",
                shipping_first_name: "",
                shipping_last_name: "",
                shippingaddress_type: "",
                is_paypal: "",
                is_pay_later: 0,
                is_cod: 0,
                is_credit_card: 1,
                is_payvia_terms: 0,
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2), //new Date().getMonth() + 1,
                cardexpireyear: new Date().getFullYear().toString().substr(-2),
                cardexpiredate: "",
                cardnumber: "",
                cardsecuritycode: "",
                is_saved_card: false,
                customerProfileId: "",
                customerPaymentProfileId: "",
                grand_total: 0,
                sales_tax: 0,
                order_price: 0,
                total_non_standard_fees: 0
            },
            shipping_methods: [],
            selected_shiping_method: null,
            all_payment_methods: [],
            credit_limit: 0,
            address1_suggestion: null,
            address2_suggestion: null,
            pincode_suggestion: null,
            city_suggestion: null,
            state_suggestion: null,
            newAddress: {
                address1: "",
                address2: "",
                state: "",
                city: "",
                country: null,
                pincode: "",
                phone: "",
                email: "",
                address_verified: 0,
                address1_suggestion: "",
                address2_suggestion: "",
                city_suggestion: "",
                state_suggestion: "",
                pincode_suggestion: "",
                address_title: "",
                address_label: "",
                address_type: null
            },
            temp_address: null,
            reloadDeliveryAddressInput: true,
            reloadShippingAddressSelect: true,
            reloadNewAddressCountrySelect: true,
            address_types: CommonData.address_types,
            CommonData: CommonData,
            address_type_error: "",
            showOrderDrawer: false
        };
    },
    mounted() {
        document.body.classList.add("bg_primary_light_white");
        this.getUser();
        this.getStates();
        this.getCountries();
        var _this = this;
        /* eslint-disable */
        $(document).on("hide.bs.modal", "#address", function () {
            _this.$validator.reset();
            _this.address_data = {
                address1: "",
                address2: "",
                state: "",
                city: "",
                pincode: ""
            };
            //Do stuff here
        });
        /* eslint-enable */
        _this.getShippingCarriers();
        _this.reloadDeliveryAddressInput = false;
        _this.reloadShippingAddressSelect = false;
        this.getAddresses()
            .then(async () => {
                try {
                    if (
                        _this.shipping_option === "ship_to_address" &&
                        _this.all_shipping_address.length > 0
                    ) {
                        let firstAddress = _this.all_shipping_address.find(
                            (address) =>
                                address.address_type ===
                                "Default Shipping Address"
                        );
                        if (!firstAddress) {
                            firstAddress = _this.all_shipping_address[0];
                        }
                        await _this.onChangeDeliveryAddress(firstAddress.id);
                        if (_this.shippingCarriers.length > 0) {
                            let firstShippingMethod =
                                _this.shippingCarriers[0];
                            _this.order_data.shippingproviderid =
                                firstShippingMethod.id;
                            _this.getShippingProviderImage(
                                firstShippingMethod.id,
                                firstShippingMethod.shpping_provider
                            );
                        }
                    }
                    if (_this.all_billing_address.length > 0) {
                        let firstAddress = _this.all_billing_address.find(
                            (address) =>
                                address.address_type ==
                                "Default Billing Address"
                        );
                        if (!firstAddress) {
                            firstAddress = _this.all_billing_address[0];
                        }
                    }
                } finally {
                    _this.reloadDeliveryAddressInput = true;
                    _this.reloadShippingAddressSelect = true;
                }
            })
            .catch((err) => {
                console.error("getAddresses failed:", err);
                _this.reloadDeliveryAddressInput = true;
                _this.reloadShippingAddressSelect = true;
            });

        const dict = {
            custom: {
                CardNumber: {
                    min: "Card Number should atleast 14 digits.",
                    max: "Card Number can not exceed 16 digits."
                },
                PhoneNumber: {
                    length: "Phone Number must be 10 digits."
                }
            }
        };

        // Validator.localize('en', dict);
        // or use the instance method
        _this.$validator.localize("en", dict);
    },
    computed: {
        ...mapGetters(["isAuthenticatedClient", "currentUserClient"]),
        years() {
            const year = new Date().getFullYear();
            return Array.from({ length: 15 }, (value, index) => year + index);
        },
        /** Shipping address book entry required only for ship-to-address (not pickup / delivery). */
        isShippingAddressRequired() {
            return this.shipping_option === "ship_to_address";
        },
        /** Ship-to flow only: hide shipping dropdown, same-as-billing checkbox, and shipping add-new when pickup/delivery. */
        showShipToAddressControls() {
            return this.shipping_option === "ship_to_address";
        },
        shippingAddressPlaceholder() {
            return this.isShippingAddressRequired
                ? "Select Address"
                : "Choose an address";
        }
    },
    methods: {
        onChangeAddressType(address_type, id = null) {
            this.address_type_error = "";
            if (
                address_type != "Additional Shipping Address" &&
                address_type != "Additional Billing Address"
            ) {
                if (id == null) {
                    let address = this.addresses.find(
                        (add) => add.address_type == address_type
                    );
                    if (address != undefined) {
                        this.address_type_error =
                            address_type + " has been selected already";
                    }
                } else {
                    let address = this.addresses.find(
                        (add) =>
                            add.address_type == address_type && add.id != id
                    );
                    if (address != undefined) {
                        this.address_type_error =
                            address_type + " has been selected already";
                    }
                }
            }
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        /** Pickup / delivery: no ship-to address; clear selection and show placeholder. */
        clearShippingAddressSelection() {
            const _this = this;
            _this.order_data.shipping_first_name = "";
            _this.order_data.shipping_last_name = "";
            _this.order_data.shippingaddresszip = "";
            _this.order_data.shippingaddressstate = 0;
            _this.order_data.shipping_full_address = "";
            _this.order_data.shippingaddress1 = "";
            _this.order_data.shippingaddress2 = "";
            _this.order_data.shippingcity = "";
            _this.order_data.shippingcountry = "US";
            _this.order_data.shipping_address_verified = 0;
            _this.order_data.shippingaddressid = null;
            _this.order_data.shippingaddress_label = "";
            _this.order_data.shippingaddress_title = "";
            _this.order_data.shippingaddress_type = "";
            _this.shipping_methods = [];
            if (_this.$parent) {
                _this.$parent.selected_shiping_method = null;
            }
            _this.selected_shiping_method = null;
            _this.order_data.shippingproviderid = "";
            _this.$nextTick(() => {
                if (_this.$validator && _this.$validator.errors) {
                    _this.$validator.errors.remove(
                        "shippingandpaymentform.shippingAddress"
                    );
                }
            });
            if (
                this.shipping_option === "pickup_warehouse" ||
                this.shipping_option === "delivery"
            ) {
                this.order_data.sameaddress = false;
                if (this.activeAddressType === "shipping") {
                    this.showInlineAddressForm = false;
                }
                this.$nextTick(() => {
                    this.applyPickupDeliveryStaticShipping();
                });
            }
        },
        /**
         * After pickup/delivery, switching back to ship-to: re-check "same as billing"
         * and reload shipping + billing from the selected billing address.
         */
        restoreShipToAddressSameAsBilling() {
            let id = this.order_data.billingaddressid;
            if (
                !id &&
                this.all_billing_address &&
                this.all_billing_address.length
            ) {
                const first =
                    this.all_billing_address.find(
                        (a) => a.address_type == "Default Billing Address"
                    ) || this.all_billing_address[0];
                id = first && first.id;
            }
            this.order_data.sameaddress = true;
            if (!id) {
                return;
            }
            this.$nextTick(() => {
                this.onChangeDeliveryAddress(id);
            });
        },
        getUser() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/user-profile").then(({ data }) => {
                    let user = data.user;
                    // console.log(user, user["email_activation"], "aaaaaaaa");
                    _this.order_data.fullname =
                        _this.capitalize(user["first_name"]) +
                        " " +
                        _this.capitalize(user["last_name"]);
                    _this.order_data.firstName = _this.capitalize(
                        user["first_name"]
                    );
                    _this.order_data.lastName = _this.capitalize(
                        user["last_name"]
                    );
                    _this.order_data.email = user["email"];
                    if (!user["email_activation"]) {
                        _this.email_confirmation = true;
                    }
                    let phone_number = user["mobile"] ? user["mobile"] : "";
                    if (user["Profile"]) {
                        phone_number = user["Profile"]["phone_no"]
                            ? user["Profile"]["phone_no"]
                            : "";
                    }
                    let x = phone_number
                        .replace(/\D/g, "")
                        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    _this.order_data.phone = !x[2]
                        ? x[1]
                        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
                    _this.$nextTick(() => {
                        if (_this.showInlineAddressForm) {
                            _this.applyNewAddressCustomerDefaults();
                        }
                    });
                });
                // _this.all_billing_address = address;
                // _this.all_shipping_address = address;
            }).catch(({ response }) => {
                console.log(response.status);
                if (response.status == 401) {
                    _this.$router.push({ name: "/admin/login" });
                }
            });
        },
        capitalize(value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        calculate_shipping() {
            if (!this.selected_shiping_method) {
                if (this.$parent) {
                    this.$parent.selected_shiping_method = null;
                }
                return;
            }
            this.order_data.shippingmethod =
                this.selected_shiping_method.serviceName;
            this.$parent.order_data.shippingmethod =
                this.selected_shiping_method.serviceName;
            // this.order_data.order_price = parseFloat(this.$parent.order_data.grand_total);
            if (this.selected_shiping_method) {
                /*  this.$parent.order_data.order_price += parseFloat(
                    this.selected_shiping_method.total
                );
                this.order_data.order_price +=
                    this.$parent.order_data.order_price; */
            }
            this.$parent.selected_shiping_method = this.selected_shiping_method;
        },
        acceptNumber() {
            var x = this.order_data.phone
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.order_data.phone = !x[2]
                ? x[1]
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
        },
        acceptShippingNumber() {
            var x = this.order_data.shippingphone
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.order_data.shippingphone = !x[2]
                ? x[1]
                : "" + x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        },
        cardNumberFormate() {
            if (this.order_data.cardnumber.replace(/\s/g, "").length < 14) {
                this.masklength = "";
            }
            if (this.order_data.cardnumber.replace(/\s/g, "").length == 14) {
                this.masklength = 14;
            }
            if (this.order_data.cardnumber.replace(/\s/g, "").length == 15) {
                this.masklength = 15;
            }
            if (this.order_data.cardnumber.replace(/\s/g, "").length == 16) {
                this.masklength = 16;
            }
            if (this.order_data.cardnumber.replace(/\s/g, "").length > 16) {
                this.masklength = 17;
            }
        },
        cardSecurityFormate() {
            var x = this.order_data.cardsecuritycode
                .replace(/\D/g, "")
                .match(/(\d{0,3})/);
            this.order_data.cardsecuritycode = !x[2]
                ? x[1]
                : "" + x[1] + "" + x[2] + (x[3] ? "" + x[3] : "");
        },
        changeCardYear(event) {
            var _this = this;
            _this.changedYear = event.target.value;
            if (_this.changedYear == _this.currentYear) {
                _this.order_data.cardexpiremonth = (
                    "0" +
                    (new Date().getMonth() + 1)
                ).slice(-2); //new Date().getMonth() + 1;
            } else {
                _this.order_data.cardexpiremonth = "01";
            }
        },
        getStates() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/states")
                    .then(({ data }) => {
                        // console.log(data);
                        _this.all_states = data.states;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        getCountries() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/countries")
                    .then(({ data }) => {
                        // console.log(data);
                        _this.all_countries = data.countries;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        getAddresses() {
            var _this = this;
            return new Promise((resolve, reject) => {
                ApiService.get("/addresses")
                    .then(({ data }) => {
                        // console.log(data);
                        var address = [];
                        data.address.forEach((elem) => {
                            const cleaned = elem.address
                                ? elem.address.replace(", ,", ",")
                                : "";
                            const title =
                                elem.address_title != null &&
                                String(elem.address_title).trim() !== ""
                                    ? String(elem.address_title).trim()
                                    : "";
                            const displayAddress = title
                                ? cleaned
                                    ? `${title}, ${cleaned}`
                                    : title
                                : cleaned;
                            address.push({
                                id: elem.id,
                                address_type: elem.address_type,
                                address_label: elem.address_label,
                                address_title: elem.address_title,
                                first_name: elem.first_name,
                                last_name: elem.last_name,
                                address: displayAddress
                            });
                        });
                        //console.log(address);
                        _this.all_billing_address = address;
                        _this.all_shipping_address = address;
                        _this.addresses = address;

                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },
        verifyUSAddress() {
            var _this = this;

            //  _this.isBusy = false;

            // let returnresp = new Promise((resolve) => {
            _this.$validator
                .validateAll("shippingandpaymentform")
                .then((isValid) => {
                    if (isValid) {
                        _this.isBusy = true;
                        ApiService.post("/verify-address", _this.order_data)

                            .then(({ data }) => {
                                _this.isBusy = false;
                                console.log(
                                    data,
                                    "ddataaaaaaaaaaaaaaaaaaaaaaa"
                                );
                                let address_verified = 0;
                                // _this.isBusy = true;
                                let address_id =
                                    _this.order_data.billingaddressid;

                                if (data.success) {
                                    address_verified = 1;

                                    ApiService.post("/update-verifiedaddress", {
                                        address_verified: address_verified,
                                        address_id: address_id
                                    }).then(({ data }) => {
                                        _this.order_data.address_verified = 1;
                                        _this.addShippingAndPaymentDetail();
                                        //  _this.isBusy = false;
                                        _this.$toast.success(data.message, {
                                            position: "top-right"
                                        });
                                        _this.isBusy = false;
                                    });
                                }
                            })
                            .catch(({ response }) => {
                                _this.isBusy = false;
                                console.log(response.status);

                                console.log(
                                    response.data.error,
                                    "Please Enter Valid Address"
                                );
                                _this.isBusy = false;
                                _this.$toast.error(response.data.error, {
                                    position: "top-right"
                                });
                                if (response.status == 401) {
                                    _this.$router.push({
                                        name: "/admin/login"
                                    });
                                }
                            });
                        // });
                    }
                });
        },
        getAddress(id) {
            return new Promise((resolve, reject) => {
                ApiService.post("/getstateandzipcode/" + id)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        fillDeliveryAddressForm(data) {
            this.order_data.shipping_address_verified = data.address_verified;
            this.order_data.shippingaddresszip = data.pincode;
            this.order_data.shippingaddressstate = data.state;
            this.order_data.shipping_full_address = data.complete_address;
            this.order_data.shippingaddress1 = data.address1;
            this.order_data.shippingaddress2 = data.address2;
            this.order_data.shippingcity = data.city;
            this.order_data.shippingcountry = data.country;
            this.order_data.shippingaddressid = data.id;
            this.order_data.shippingaddress_label = data.address_label;
            this.order_data.shippingaddress_title = data.address_title;
            this.order_data.shippingaddress_type = data.address_type;
            this.order_data.shipping_first_name = data.first_name;
            this.order_data.shipping_last_name = data.last_name;
        },
        fillBillingAddressForm(data) {
            this.order_data.address_verified = data.address_verified;
            this.order_data.addresszip = data.pincode;
            this.order_data.addressstate = data.state;
            this.order_data.full_address = data.complete_address;
            this.order_data.address1 = data.address1;
            this.order_data.address2 = data.address2;
            this.order_data.city = data.city;
            this.order_data.address_label = data.address_label;
            this.order_data.address_title = data.address_title;
            this.order_data.address_type = data.address_type;
            this.order_data.billingcountry = data.country;
            this.order_data.billingaddressid = data.id;
            this.order_data.billing_first_name = data.first_name;
            this.order_data.billing_last_name = data.last_name;
        },
        onChangeDeliveryAddress(id) {
            var _this = this;
            // Store the previously selected shipping provider before clearing
            var previousShippingProviderId = _this.order_data.shippingproviderid;
            var previousShippingProvider = _this.shippingCarriers.find(
                (carrier) => carrier.id == previousShippingProviderId
            );

            _this.order_data.shipping_first_name = "";
            _this.order_data.shipping_last_name = "";
            _this.order_data.shippingaddresszip = "";
            _this.order_data.shippingaddressstate = 0;
            _this.order_data.shipping_full_address = "";
            _this.order_data.shippingaddress1 = "";
            _this.order_data.shippingaddress2 = "";
            _this.order_data.shippingcity = "";
            _this.order_data.shipping_address_verified = 0;
            _this.order_data.shippingaddressid = null;

            _this.shipping_methods = [];
            _this.$parent.selected_shiping_method = null;
            _this.selected_shiping_method = null;
            _this.order_data.shippingproviderid = "";

            _this.$validator.reset();

            return new Promise((resolve) => {
                _this
                    .getAddress(id)
                    .then((data) => {
                        _this.fillDeliveryAddressForm(data.zipAndState);

                        if (_this.order_data.sameaddress) {
                            _this.fillBillingAddressForm(data.zipAndState);
                        }

                        // Automatically reload shipping methods if there was a previously selected provider
                        if (
                            previousShippingProvider &&
                            _this.shippingCarriers.length > 0
                        ) {
                            _this.$nextTick(() => {
                                _this.order_data.shippingproviderid =
                                    previousShippingProviderId;
                                _this.getShippingProviderImage(
                                    previousShippingProviderId,
                                    previousShippingProvider.shpping_provider
                                );
                            });
                        } else if (_this.shippingCarriers.length > 0) {
                            // If no previous provider, select the first one automatically
                            _this.$nextTick(() => {
                                let firstShippingMethod =
                                    _this.shippingCarriers[0];
                                _this.order_data.shippingproviderid =
                                    firstShippingMethod.id;
                                _this.getShippingProviderImage(
                                    firstShippingMethod.id,
                                    firstShippingMethod.shpping_provider
                                );
                            });
                        }

                        resolve(data);
                    })
                    .catch((err) => {
                        console.error(
                            "[ShippingPayment] onChangeDeliveryAddress getAddress failed",
                            err
                        );
                        resolve(null);
                    });
            });
        },
        onChangeBillingAddress(id) {
            this.order_data.billing_first_name = "";
            this.order_data.billing_last_name = "";
            this.order_data.addresszip = "";
            this.order_data.addressstate = 0;
            this.order_data.full_address = "";
            this.order_data.address1 = "";
            this.order_data.address2 = "";
            this.order_data.city = "";
            this.order_data.address_verified = 0;
            this.order_data.billingaddressid = null;

            // Don't reset shipping methods - billing address change shouldn't affect shipping
            // Only reset billing address related validation
            this.$nextTick(() => {
                this.$validator.errors.remove(
                    "shippingandpaymentform.billingAddress"
                );
            });

            this.getAddress(id).then((data) => {
                this.fillBillingAddressForm(data.zipAndState);
            });
        },

        getStateAndZipCode(id, reset_providers = true) {
            var _this = this;
            _this.order_data.address_verified = 0;
            // this.resetSuggestions();
            if (id == null) {
                // alert("empty")
                _this.order_data.addresszip = "";
                _this.order_data.addressstate = 0;
                _this.order_data.full_address = "";
                _this.order_data.address1 = "";
                _this.order_data.address2 = "";
                _this.order_data.city = "";
                _this.order_data.address_verified = 0;
            }
            new Promise(() => {
                ApiService.post("/getstateandzipcode/" + id)
                    .then(({ data }) => {
                        _this.order_data.address_verified =
                            data.zipAndState.address_verified;
                        _this.order_data.addresszip = data.zipAndState.pincode;
                        _this.order_data.addressstate = data.zipAndState.state;
                        _this.order_data.full_address =
                            data.zipAndState.complete_address;
                        _this.order_data.address1 = data.zipAndState.address1;
                        _this.order_data.address2 = data.zipAndState.address2;
                        _this.order_data.city = data.zipAndState.city;
                        _this.order_data.billingcountry =
                            data.zipAndState.country;
                        _this.newBillingAddress = false;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
            console.log("aaaaaaaaaaaaaaaaa");
            if (reset_providers) {
                _this.$parent.order_data.sales_tax = 0;
                _this.shipping_methods = [];
                _this.$parent.selected_shiping_method = null;
                _this.selected_shiping_method = null;
                _this.order_data.shippingproviderid = "";
            }
        },
        getShippingStateAndZipCode(id, reset_providers = true) {
            var _this = this;
            console.log(id);
            if (id == null) {
                _this.order_data.shippingaddresszip = "";
                _this.order_data.shippingaddressstate = 0;
                _this.order_data.shipping_full_address = "";
                _this.order_data.shippingaddress1 = "";
                _this.order_data.shippingaddress2 = "";
                _this.order_data.shippingcity = "";
            }
            new Promise(() => {
                ApiService.post("/getstateandzipcode/" + id)
                    .then(({ data }) => {
                        _this.order_data.shippingaddresszip =
                            data.zipAndState.pincode;
                        _this.order_data.shippingaddressstate =
                            data.zipAndState.state;
                        _this.order_data.shipping_full_address =
                            data.zipAndState.complete_address;
                        _this.order_data.shippingaddress1 =
                            data.zipAndState.address1;
                        _this.order_data.shippingaddress2 =
                            data.zipAndState.address2;
                        _this.order_data.shippingcity = data.zipAndState.city;
                        _this.order_data.shippingcountry = data.zipAndState
                            .country
                            ? data.zipAndState.country
                            : "US";
                        _this.newShippingAddress = false;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
            if (reset_providers) {
                _this.$parent.order_data.sales_tax = 0;
                _this.shipping_methods = [];
                _this.$parent.selected_shiping_method = null;
                _this.selected_shiping_method = null;
                _this.order_data.shippingproviderid = "";
            }
        },
        /**
         * Pickup at warehouse / Delivery: skip live FedEx rate API.
         * Carrier = FedEx (from carrier list); method = Warehouse (pickup) or Pick-Up (delivery).
         */
        async applyPickupDeliveryStaticShipping() {
            const _this = this;
            const shippingOption =
                (_this.order_data && _this.order_data.shipping_option) ||
                _this.shipping_option ||
                "ship_to_address";
            if (
                shippingOption !== "pickup_warehouse" &&
                shippingOption !== "delivery"
            ) {
                return;
            }
            if (!_this.shippingCarriers || !_this.shippingCarriers.length) {
                try {
                    await _this.getShippingCarriers();
                } catch (e) {
                    return;
                }
            }
            const fedexCarrier =
                _this.shippingCarriers.find((c) =>
                    String(c.shpping_provider || "")
                        .toLowerCase()
                        .includes("fedex")
                ) ||
                _this.shippingCarriers.find((c) => Number(c.id) === 2) ||
                _this.shippingCarriers[0];
            if (!fedexCarrier) {
                return;
            }
            _this.order_data.shippingproviderid = fedexCarrier.id;
            _this.order_data.shipping_provider_name =
                fedexCarrier.shpping_provider;
            _this.order_data.shippingproviderimage =
                fedexCarrier.image_url || "";

            const serviceName =
                shippingOption === "pickup_warehouse"
                    ? "Warehouse"
                    : "Pick-Up";
            const staticMethod = { serviceName, total: 0 };
            _this.shipping_methods = [staticMethod];
            _this.selected_shiping_method = staticMethod;

            await _this.$nextTick();
            const billingZip = _this.order_data.addresszip || "";
            if (billingZip) {
                try {
                    await _this.getSalesTax(billingZip);
                } catch (e) {
                    /* non-fatal */
                }
            }
            _this.calculate_shipping();
            _this.$nextTick(() => {
                if (_this.$validator && _this.$validator.errors) {
                    _this.$validator.errors.remove(
                        "shippingandpaymentform.Shipping_Methods"
                    );
                    _this.$validator.errors.remove(
                        "shippingandpaymentform.shippingproviderid"
                    );
                }
            });
        },
        async getShippingProviderImage(id, shipping_provider) {
            // this.resetSuggestions();
            var _this = this;
            
            // Get shipping_option from order_data or parent component
            let shippingOption = (_this.order_data && _this.order_data.shipping_option) || 
                                (_this.$parent && _this.$parent.shipping_option) || 
                                (_this.$parent && _this.$parent.order_data && _this.$parent.order_data.shipping_option) ||
                                "ship_to_address";
            
            // Address check is only required for "ship_to_address" option
            // For "pickup_warehouse" or "delivery", address is not required
            if (shippingOption === "ship_to_address") {
                if (!_this.order_data.shippingaddressid) {
                    setTimeout(() => {
                        _this.order_data.shippingproviderid = "";
                        _this.selected_shiping_method = null;
                        _this.$forceUpdate();
                    }, 200);
                    _this.$toast.error("Please select delivery address.", {
                        position: "top-right",
                        queue: true
                    });
                    return;
                } else if (!_this.order_data.billingaddressid) {
                    setTimeout(() => {
                        _this.order_data.shippingproviderid = "";
                        _this.selected_shiping_method = null;
                        _this.$forceUpdate();
                    }, 200);
                    _this.$toast.error("Please select billing address.", {
                        position: "top-right",
                        queue: true
                    });
                    return;
                }
            }
            // Pickup / delivery: no UPS/FedEx/USPS rate APIs — static FedEx + method
            if (
                shippingOption === "pickup_warehouse" ||
                shippingOption === "delivery"
            ) {
                await _this.applyPickupDeliveryStaticShipping();
                return;
            }
            _this.order_data.shipping_provider_name = shipping_provider;
            if (id == 1) {
                _this.isBusy = true;
                _this.order_data.total_weight_in_lbs =
                    _this.$parent.total_weight_in_lbs;
                new Promise(() => {
                    ApiService.post("/getShippingRates/ups", {
                        order_data: _this.order_data
                    })
                        .then(async ({ data }) => {
                            if (data.success == true) {
                                if (_this.order_data.sameaddress) {
                                    await _this.getSalesTax(
                                        _this.order_data.addresszip
                                    );
                                } else if (
                                    _this.order_data.shippingaddresszip
                                ) {
                                    await _this.getSalesTax(
                                        _this.order_data.shippingaddresszip
                                    );
                                }
                                _this.shipping_methods = data.result;
                                _this.order_data.shippingproviderimage =
                                    data.image_url;
                                if (
                                    _this.shipping_methods &&
                                    _this.shipping_methods.length > 0
                                ) {
                                    _this.selected_shiping_method =
                                        _this.shipping_methods[0];
                                    _this.calculate_shipping();
                                } else {
                                    _this.selected_shiping_method = null;
                                }
                            } else {
                                _this.shipping_methods = [];
                                _this.$parent.selected_shiping_method = null;
                                _this.selected_shiping_method = null;
                                _this.order_data.shippingproviderid = "";
                                if (!data.success) {
                                    if (typeof data.error == "object") {
                                        this[`${data.error.field}_suggestion`] =
                                            data.error.suggestion;
                                        this.$toast.error(
                                            data.error.error_message,
                                            {
                                                position: "top-right",
                                                queue: true
                                            }
                                        );
                                    } else {
                                        this.$toast.error(data.error, {
                                            position: "top-right",
                                            queue: true
                                        });
                                    }
                                }
                            }
                            _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            this.order_data.address_verified = 0;
                            _this.shipping_methods = [];
                            _this.$parent.selected_shiping_method = null;
                            _this.selected_shiping_method = null;
                            _this.order_data.shippingproviderid = "";
                            if (response.status == 400) {
                                response.data.error.forEach((element) => {
                                    _this.$toast.error(element.message, {
                                        position: "top-right"
                                    });
                                });
                            }
                            _this.isBusy = false;
                        });
                });
            } else if (id == 2) {
                _this.isBusy = true;
                _this.order_data.total_weight_in_lbs =
                    _this.$parent.total_weight_in_lbs;
                new Promise(() => {
                    ApiService.post("/getShippingRates/fedex", {
                        shipping_address: {
                            address1: _this.order_data.shippingaddress1,
                            address2: _this.order_data.shippingaddress2,
                            state: _this.order_data.shippingaddressstate,
                            city: _this.order_data.shippingcity,
                            country: _this.order_data.shippingcountry,
                            zipcode: _this.order_data.shippingaddresszip
                        }
                    })
                        .then(async ({ data }) => {
                            if (data.success == true) {
                                // Get shipping_option from order_data or parent component
                                let shippingOption = (_this.order_data && _this.order_data.shipping_option) || 
                                                    (_this.$parent && _this.$parent.shipping_option) || 
                                                    (_this.$parent && _this.$parent.order_data && _this.$parent.order_data.shipping_option) ||
                                                    "ship_to_address";
                                
                                if (
                                    data.result &&
                                    data.result.shippingMethods
                                ) {
                                    // Filter shipping methods based on shipping_option
                                    let allMethods = data.result.shippingMethods;
                                    
                                    if (shippingOption === "pickup_warehouse" || shippingOption === "delivery") {
                                        // For pickup at warehouse or delivery, only show Warehouse option
                                        _this.shipping_methods = allMethods.filter(
                                            (method) => method.serviceName === "Pick-Up"
                                        );
                                    } else {
                                        // For ship to address, exclude Warehouse option
                                        _this.shipping_methods = allMethods.filter(
                                            (method) => method.serviceName !== "Pick-Up"
                                        );
                                    }
                                } else {
                                    _this.shipping_methods = [];
                                    _this.$parent.selected_shiping_method =
                                        null;
                                    _this.selected_shiping_method = null;
                                    _this.order_data.shippingproviderid = "";
                                    _this.isBusy = false;
                                    _this.$toast.error("Something went wrong", {
                                        position: "top-right",
                                        queue: true
                                    });
                                    return;
                                }
                                if (_this.order_data.sameaddress) {
                                    await _this.getSalesTax(
                                        _this.order_data.addresszip
                                    );
                                } else if (
                                    _this.order_data.shippingaddresszip
                                ) {
                                    await _this.getSalesTax(
                                        _this.order_data.shippingaddresszip
                                    );
                                }
                                _this.order_data.shippingproviderimage =
                                    data.image_url;
                                if (
                                    _this.shipping_methods &&
                                    _this.shipping_methods.length > 0
                                ) {
                                    // Auto-select based on shipping option
                                    if (shippingOption === "pickup_warehouse" || shippingOption === "delivery") {
                                        // For pickup/delivery, prioritize Warehouse
                                        let warehouseMethod = _this.shipping_methods.find(
                                            (method) => method.serviceName === "Warehouse"
                                        );
                                        if (warehouseMethod) {
                                            _this.selected_shiping_method = warehouseMethod;
                                        } else {
                                            _this.selected_shiping_method = _this.shipping_methods[0];
                                        }
                                    } else {
                                        // For ship to address, prioritize FedEx Ground®
                                        let fedexGround =
                                            _this.shipping_methods.find(
                                                (method) =>
                                                    method.serviceName ==
                                                    "FedEx Ground®"
                                            );
                                        if (fedexGround) {
                                            _this.selected_shiping_method =
                                                fedexGround;
                                        } else {
                                            _this.selected_shiping_method =
                                                _this.shipping_methods[0];
                                        }
                                    }
                                    _this.calculate_shipping();
                                } else {
                                    _this.selected_shiping_method = null;
                                }
                            } else {
                                _this.shipping_methods = [];
                                _this.$parent.selected_shiping_method = null;
                                _this.selected_shiping_method = null;
                                _this.order_data.shippingproviderid = "";
                                if (!data.success) {
                                    if (typeof data.error == "object") {
                                        this[`${data.error.field}_suggestion`] =
                                            data.error.suggestion;
                                        this.$toast.error(
                                            data.error.error_message,
                                            {
                                                position: "top-right",
                                                queue: true
                                            }
                                        );
                                    } else {
                                        this.$toast.error(data.error, {
                                            position: "top-right",
                                            queue: true
                                        });
                                    }
                                }
                            }
                            _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            _this.shipping_methods = [];
                            _this.$parent.selected_shiping_method = null;
                            _this.selected_shiping_method = null;
                            _this.order_data.shippingproviderid = "";
                            if (response.status == 400) {
                                response.data.error.forEach((element) => {
                                    _this.$toast.error(element.message, {
                                        position: "top-right"
                                    });
                                });
                            }
                            _this.isBusy = false;
                        });
                });
            } else if (id == 3) {
                _this.isBusy = true;
                _this.order_data.total_weight_in_lbs =
                    _this.$parent.total_weight_in_lbs;
                new Promise(() => {
                    ApiService.post("/getShippingRates/usps", {
                        order_data: _this.order_data
                    })
                        .then(async ({ data }) => {
                            if (data.success == true) {
                                if (_this.order_data.sameaddress) {
                                    await _this.getSalesTax(
                                        _this.order_data.addresszip
                                    );
                                } else if (
                                    _this.order_data.shippingaddresszip
                                ) {
                                    await _this.getSalesTax(
                                        _this.order_data.shippingaddresszip
                                    );
                                }
                                _this.shipping_methods = data.result;
                                _this.order_data.shippingproviderimage =
                                    data.image_url;
                                if (
                                    _this.shipping_methods &&
                                    _this.shipping_methods.length > 0
                                ) {
                                    _this.selected_shiping_method =
                                        _this.shipping_methods[0];
                                    _this.calculate_shipping();
                                } else {
                                    _this.selected_shiping_method = null;
                                }
                            } else {
                                _this.shipping_methods = [];
                                _this.$parent.selected_shiping_method = null;
                                _this.selected_shiping_method = null;
                                _this.order_data.shippingproviderid = "";
                                if (!data.success) {
                                    if (typeof data.error == "object") {
                                        _this[
                                            `${data.error.field}_suggestion`
                                        ] = data.error.suggestion;
                                        _this.$toast.error(
                                            data.error.error_message,
                                            {
                                                position: "top-right",
                                                queue: true
                                            }
                                        );
                                    } else {
                                        _this.$toast.error(data.error, {
                                            position: "top-right",
                                            queue: true
                                        });
                                    }
                                }
                            }
                            this.$nextTick(() => {
                                this.$validator.reset();
                            });
                            _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            _this.shipping_methods = [];
                            _this.$parent.selected_shiping_method = null;
                            _this.selected_shiping_method = null;
                            _this.order_data.shippingproviderid = "";
                            if (response.status == 400) {
                                response.data.error.forEach((element) => {
                                    _this.$toast.error(element.message, {
                                        position: "top-right"
                                    });
                                });
                            }
                            _this.isBusy = false;
                        });
                });
            } else {
                _this.shipping_methods = [];
                _this.$parent.selected_shiping_method = null;
                _this.selected_shiping_method = null;
            }
        },
        resetSuggestions(data) {
            data.address1_suggestion = null;
            data.address2_suggestion = null;
            data.city_suggestion = null;
            data.pincode_suggestion = null;
            data.state_suggestion = null;
        },
        /** Prefill new-address form from logged-in customer (order_data from /user-profile). */
        applyNewAddressCustomerDefaults() {
            const od = this.order_data || {};
            if (od.firstName) {
                this.newAddress.first_name = od.firstName;
            }
            if (od.lastName) {
                this.newAddress.last_name = od.lastName;
            }
            if (od.email) {
                this.newAddress.email = od.email;
            }
            if (od.phone) {
                this.newAddress.phone = od.phone;
            }
            // Default country: United States (v-select value is country code)
            this.newAddress.country = "US";
        },
        resetNewAddressForm() {
            this.newAddress = {
                first_name: "",
                last_name: "",
                address1: "",
                address2: "",
                state: "",
                city: "",
                country: null,
                pincode: "",
                phone: "",
                email: "",
                address_verified: 0,
                address1_suggestion: "",
                address2_suggestion: "",
                city_suggestion: "",
                state_suggestion: "",
                pincode_suggestion: "",
                address_title: "",
                address_label: "",
                address_type: null
            };
            this.applyNewAddressCustomerDefaults();
            this.address_type_error = "";
            this.reloadNewAddressCountrySelect = false;
            this.$nextTick(() => {
                this.reloadNewAddressCountrySelect = true;
            });
        },
        resetShippingProvider() {
            this.shipping_methods = [];
            this.$parent.order_data.sales_tax = 0;
            this.$parent.selected_shiping_method = null;
            this.selected_shiping_method = null;
            this.order_data.shippingproviderid = "";
            // Clear validation errors for shipping fields
            this.$nextTick(() => {
                this.$validator.errors.remove(
                    "shippingandpaymentform.shippingproviderid"
                );
                this.$validator.errors.remove(
                    "shippingandpaymentform.Shipping_Methods"
                );
            });
        },
        verifyAddressWithUSPS(newAddressData) {
            // this.isBusy = true;
            // this.resetSuggestions();
            newAddressData.address_verified = 0;
            let params = {
                address1: newAddressData.address1,
                address2: newAddressData.address2,
                city: newAddressData.city,
                addressstate: newAddressData.state,
                addresszip: newAddressData.pincode
            };
            return new Promise((resolve, reject) => {
                ApiService.post("/verifyAddress/usps", params)
                    .then(({ data }) => {
                        // Check for error response first
                        if (!data.success) {
                            const errorMessage = data.error || "Address validation failed";
                            console.error("USPS Address Validation Error:", errorMessage);
                            this.$toast.error(errorMessage, {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject(data);
                            return;
                        }

                        // Handle new USPS Addresses 3.0 API response structure
                        if (!data.result) {
                            console.error("USPS Address Validation Error: No result in response", data);
                            this.$toast.error("Invalid response from address validation service", {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: "Invalid response from address validation service" });
                            return;
                        }

                        const result = data.result;
                        const address = result.address || {};
                        const additionalInfo = result.additionalInfo || {};

                        // Check DPVConfirmation - valid values are "Y" (Confirmed), "S" (Secondary confirmed), "D" (Default confirmed)
                        // "N" (Not confirmed) is invalid
                        const validDPVConfirmations = ["Y", "S", "D"];
                        if (!validDPVConfirmations.includes(additionalInfo.DPVConfirmation)) {
                            console.error("USPS Address Validation Error: DPVConfirmation is not valid", additionalInfo);
                            this.$toast.error("Invalid ZIP Code", {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: "Invalid ZIP Code" });
                            return;
                        }

                        // Check if address is vacant
                        if (additionalInfo.vacant === "Y") {
                            this.$toast.warning("This address is marked as vacant", {
                                position: "top-right",
                                queue: true
                            });
                        }

                        // Show warnings if any
                        if (result.warnings && result.warnings.length > 0) {
                            result.warnings.forEach(warning => {
                                this.$toast.warning(warning.message || "Address validation warning", {
                                    position: "top-right",
                                    queue: true
                                });
                            });
                        }

                        // Validate ZIP code first - if ZIP is wrong, reject
                        if (address.ZIPCode && newAddressData.pincode != address.ZIPCode) {
                            newAddressData.pincode_suggestion = address.ZIPCode;
                            this.$toast.error("Invalid Zip / PostalCode", {
                                position: "top-right",
                                queue: true
                            });
                            reject(data);
                            return;
                        }

                        // Validate state - if state is wrong, reject
                        if (address.state && newAddressData.state != address.state) {
                            newAddressData.state_suggestion = address.state;
                            this.$toast.error("Invalid State", {
                                position: "top-right",
                                queue: true
                            });
                            reject(data);
                            return;
                        }

                        // Validate city - if city is wrong, reject
                        if (address.city && newAddressData.city.toLowerCase() != address.city.toLowerCase()) {
                            newAddressData.city_suggestion = address.city;
                            this.$toast.error("Invalid City", {
                                position: "top-right",
                                queue: true
                            });
                            reject(data);
                            return;
                        }

                        // If ZIP code is correct but address1 doesn't match, show correction (not error)
                        if (address.streetAddress && newAddressData.address1.toLowerCase() != address.streetAddress.toLowerCase()) {
                            newAddressData.address1_suggestion = address.streetAddress;
                            // Also set in component data for template display
                            if (newAddressData === this.newAddress) {
                                this.newAddress.address1_suggestion = address.streetAddress;
                            } else {
                                this.address1_suggestion = address.streetAddress;
                            }
                            this.$toast.info(`Address correction: ${address.streetAddress}`, {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            // Don't reject - allow address to be saved with correction suggestion
                        }

                        // Validate Address 2 (secondaryAddress) - show correction only if content is different and meaningful
                        if (address.secondaryAddress && newAddressData.address2 && newAddressData.address2.trim()) {
                            // Normalize both for comparison (trim and lowercase)
                            const userAddress2 = newAddressData.address2.trim().toLowerCase();
                            const uspsAddress2 = address.secondaryAddress.trim().toLowerCase();
                            
                            // Only show suggestion if content is actually different (case-insensitive comparison)
                            // And if USPS suggestion is meaningful (not just "# R" or very short ambiguous values)
                            if (userAddress2 !== uspsAddress2) {
                                // Filter out ambiguous or very short suggestions like "# R", "#", etc.
                                const uspsTrimmed = address.secondaryAddress.trim();
                                const isMeaningfulSuggestion = uspsTrimmed.length > 2 && 
                                    !(/^#\s*[A-Z]$/i.test(uspsTrimmed)); // Don't show suggestions like "# R", "# A", etc.
                                
                                if (isMeaningfulSuggestion) {
                                    newAddressData.address2_suggestion = address.secondaryAddress;
                                    // Also set in component data for template display
                                    if (newAddressData === this.newAddress) {
                                        this.newAddress.address2_suggestion = address.secondaryAddress;
                                    } else {
                                        this.address2_suggestion = address.secondaryAddress;
                                    }
                                    this.$toast.info(`Address 2 correction: ${address.secondaryAddress}`, {
                                        position: "top-right",
                                        queue: true,
                                        duration: 5000
                                    });
                                    // Don't reject - allow address to be saved with correction suggestion
                                }
                            }
                        } else if (address.secondaryAddress && (!newAddressData.address2 || !newAddressData.address2.trim())) {
                            // If USPS returned secondaryAddress but user didn't enter address2, suggest it only if meaningful
                            const uspsTrimmed = address.secondaryAddress.trim();
                            const isMeaningfulSuggestion = uspsTrimmed.length > 2 && 
                                !(/^#\s*[A-Z]$/i.test(uspsTrimmed)); // Don't show suggestions like "# R", "# A", etc.
                            
                            if (isMeaningfulSuggestion) {
                                newAddressData.address2_suggestion = address.secondaryAddress;
                                // Also set in component data for template display
                                if (newAddressData === this.newAddress) {
                                    this.newAddress.address2_suggestion = address.secondaryAddress;
                                } else {
                                    this.address2_suggestion = address.secondaryAddress;
                                }
                                this.$toast.info(`Address 2 suggestion: ${address.secondaryAddress}`, {
                                    position: "top-right",
                                    queue: true,
                                    duration: 5000
                                });
                                // Don't reject - allow address to be saved with suggestion
                            }
                        }

                        newAddressData.address_verified = 1;
                        resolve(data);
                    })
                    .catch((error) => {
                        console.error("USPS Address Validation API Error:", error);
                        // Handle different error formats
                        let errorMessage = "Address validation failed";
                        
                        if (error.response && error.response.data) {
                            errorMessage = error.response.data.error || error.response.data.message || errorMessage;
                        } else if (error.data && error.data.error) {
                            errorMessage = error.data.error;
                        } else if (error.error) {
                            errorMessage = error.error;
                        } else if (typeof error === 'string') {
                            errorMessage = error;
                        }
                        
                        this.$toast.error(errorMessage, {
                            position: "top-right",
                            queue: true,
                            duration: 5000
                        });
                        reject(error);
                    });
            });
        },

        createNewUserAddress() {
            let params = {
                address1: this.order_data.address1,
                address2: this.order_data.address2,
                state: this.order_data.addressstate,
                city: this.order_data.city,
                country: this.order_data.billingcountry,
                pincode: this.order_data.addresszip,
                address_verified: this.order_data.address_verified,
                email: String(this.order_data.email || "").trim(),
                phone: String(this.order_data.phone || "").trim()
            };
            return new Promise((resolve, reject) => {
                ApiService.post("/address-book", params)
                    .then(({ data }) => {
                        this.newBillingAddressCreated = true;
                        this.newlyCreatedBillingAddress =
                            data.address.address1 +
                            "," +
                            data.address.address2 +
                            "," +
                            data.address.city +
                            "," +
                            data.address.state +
                            "," +
                            data.address.pincode;
                        this.order_data.billingaddressid = data.address.id;
                        localStorage.setItem(
                            "billingAddressIdAfterNewAddress",
                            JSON.stringify(data.address.id)
                        );
                        this.getStateAndZipCode(data.address.id, false);
                        this.getAddresses();
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        if (response.status == 401) {
                            this.$router.push({ name: "/admin/login" });
                        }
                        reject(response);
                    });
            });
        },
        getShippingCarriers() {
            var _this = this;
            return new Promise((resolve, reject) => {
                ApiService.get("/getShippingCarriers")
                    .then(({ data }) => {
                        _this.shippingCarriers = data.shippingCarriers;
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        sameAddress(event) {
            var _this = this;
            if (!event.target.checked) {
                _this.order_data.sameaddress = false;
                if (_this.all_billing_address.length > 0) {
                    let firstAddress = _this.all_billing_address.find(
                        (address) =>
                            address.address_type == "Default Billing Address"
                    );
                    if (!firstAddress) {
                        firstAddress = _this.all_billing_address[0];
                    }
                    _this.onChangeBillingAddress(firstAddress.id);
                }
            } else {
                _this.order_data.sameaddress = true;

                _this.onChangeBillingAddress(
                    _this.order_data.shippingaddressid
                );
            }
            // Don't reset shipping provider - billing address change shouldn't affect shipping methods
        },
        isBillingCountryUSA(country) {
            var _this = this;
            if (country == "US") {
                _this.billingCountryUSA = true;
            } else {
                _this.billingCountryUSA = false;
            }
        },
        isShippingCountryUSA(country) {
            var _this = this;
            if (country == "US") {
                _this.shippingCountryUSA = true;
            } else {
                _this.shippingCountryUSA = false;
            }
        },

        isInternationalShipping(event) {
            var _this = this;
            if (event.target.checked) {
                _this.internationalShipping = true;
            } else {
                _this.internationalShipping = false;
                _this.billingCountryUSA = true;
                _this.order_data.billingcountry = "US";
            }
        },
        addNewAddress() {
            if (this.address_type_error == "") {
                this.resetSuggestions(this.newAddress);
                this.$validator.validateAll("newaddressform").then((isValid) => {
                    if (!isValid) {
                        this.$toast.error("Please fill all required fields.", {
                            position: "top-right",
                            queue: true,
                            duration: 3000
                        });
                        return;
                    }
                        return new Promise((resolve, reject) => {
                            this.$parent.isLoader = true;

                            this.verifyAddressWithUSPS(this.newAddress)
                                .then(() => {
                                    // Check if there are any suggestions - if yes, don't close modal
                                    if (this.newAddress.address1_suggestion || this.newAddress.address2_suggestion || 
                                        this.newAddress.city_suggestion || this.newAddress.state_suggestion || 
                                        this.newAddress.pincode_suggestion) {
                                        this.$parent.isLoader = false;
                                        return; // Keep modal open so user can see and apply the suggestion
                                    }

                                    let params = {
                                        first_name: this.newAddress.first_name,
                                        last_name: this.newAddress.last_name,
                                        address1: this.newAddress.address1,
                                        address2: this.newAddress.address2,
                                        state: this.newAddress.state,
                                        city: this.newAddress.city,
                                        country: this.newAddress.country
                                            ? this.newAddress.country
                                                  .toString()
                                                  .toUpperCase()
                                                  .substring(0, 2)
                                            : "",
                                        pincode: this.newAddress.pincode,
                                        address_verified:
                                            this.newAddress.address_verified,
                                        address_label:
                                            this.newAddress.address_label,
                                        address_type:
                                            this.newAddress.address_type,
                                        address_title:
                                            this.newAddress.address_title,
                                        email: String(
                                            this.newAddress.email || ""
                                        ).trim(),
                                        phone: String(
                                            this.newAddress.phone || ""
                                        ).trim()
                                    };
                                    ApiService.post("/address-book", params)
                                        .then(({ data }) => {
                                            this.$parent.isLoader = false;
                                            if (!data.success) {
                                                // Extract error message - handle both string and object formats
                                                let errorMessage = "Failed to add address";
                                                if (typeof data.error === 'string') {
                                                    errorMessage = data.error;
                                                } else if (data.error && typeof data.error === 'object') {
                                                    errorMessage = data.error.error || data.error.message || "Failed to add address";
                                                } else if (data.error) {
                                                    errorMessage = String(data.error);
                                                }
                                                
                                                this.$toast.error(errorMessage, {
                                                    position: "top-right",
                                                    queue: true,
                                                    duration: 5000
                                                });
                                                return;
                                            }
                                            this.$toast.success("Address saved successfully.", {
                                                position: "top-right",
                                                queue: true,
                                                duration: 4000
                                            });
                                            this.showInlineAddressForm = false;
                                            this.activeAddressType = '';
                                            this.resetNewAddressForm();
                                            // this.getAddresses();
                                            /* eslint-disable */
                                            $("#addNewAddressModal").modal(
                                                "hide"
                                            );
                                            /* eslint-enable */
                                            this.loadAddressesAndSetup().then(
                                                () => {
                                                    resolve(data);
                                                }
                                            );
                                        })
                                        .catch((error) => {
                                            this.$parent.isLoader = false;
                                            console.error("Address creation error:", error);
                                            
                                            // Handle error response - extract only the error message string
                                            let errorMessage = "Failed to add address";
                                            if (error.response && error.response.data) {
                                                const errorData = error.response.data;
                                                if (typeof errorData.error === 'string') {
                                                    errorMessage = errorData.error;
                                                } else if (errorData.error && typeof errorData.error === 'object') {
                                                    errorMessage = errorData.error.error || errorData.error.message || String(errorData.error);
                                                } else if (errorData.error) {
                                                    errorMessage = String(errorData.error);
                                                }
                                            } else if (error.data) {
                                                if (typeof error.data.error === 'string') {
                                                    errorMessage = error.data.error;
                                                } else if (error.data.error && typeof error.data.error === 'object') {
                                                    errorMessage = error.data.error.error || error.data.error.message || String(error.data.error);
                                                } else if (error.data.error) {
                                                    errorMessage = String(error.data.error);
                                                }
                                            } else if (typeof error === 'string') {
                                                errorMessage = error;
                                            }
                                            
                                            this.$toast.error(errorMessage, {
                                                position: "top-right",
                                                queue: true,
                                                duration: 5000
                                            });
                                            reject(error);
                                        });
                                })
                                .catch((err) => {
                                    this.$parent.isLoader = false;
                                    reject(err);
                                });
                        });
                    });
            }
        },

        loadAddressesAndSetup() {
            return this.getAddresses()
                .then(() => {
                    if (this.all_shipping_address.length > 0) {
                        let firstAddress = this.all_shipping_address.find(
                            (address) =>
                                address.address_type ===
                                "Default Shipping Address"
                        );
                        if (!firstAddress) {
                            firstAddress = this.all_shipping_address[0];
                        }
                        return this.onChangeDeliveryAddress(
                            firstAddress.id
                        ).then(() => {
                            if (this.shippingCarriers.length > 0) {
                                let firstShippingMethod =
                                    this.shippingCarriers[0];
                                this.order_data.shippingproviderid =
                                    firstShippingMethod.id;
                                this.getShippingProviderImage(
                                    firstShippingMethod.id,
                                    firstShippingMethod.shpping_provider
                                );
                            }
                        });
                    }
                })
                .then(() => {
                    if (this.all_billing_address.length > 0) {
                        let firstBillingAddress = this.all_billing_address.find(
                            (address) =>
                                address.address_type ===
                                "Default Billing Address"
                        );
                        if (!firstBillingAddress) {
                            firstBillingAddress = this.all_billing_address[0];
                        }
                    }
                    this.reloadDeliveryAddressInput = true;
                    this.reloadShippingAddressSelect = true;
                });
        },
        updateAddress(addressData) {
            let params = {
                first_name: addressData.first_name,
                last_name: addressData.last_name,
                address_type: addressData.address_type,
                address_label: addressData.address_label,
                address_id: addressData.address_id,
                address1: addressData.address1,
                address2: addressData.address2,
                state: addressData.state,
                city: addressData.city,
                country: addressData.country,
                pincode: addressData.pincode,
                address_verified: addressData.address_verified
            };
            return new Promise((resolve, reject) => {
                ApiService.post("/update-user-address", params)
                    .then(({ data }) => {
                        this.getAddresses();
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        updateDeliveryAddress() {
            this.resetSuggestions(this);
            if (this.address_type_error == "") {
                this.$validator
                    .validateAll("deliveryaddressform")
                    .then((isValid) => {
                        if (!isValid) {
                            return;
                        }
                        this.$parent.isLoader = true;

                        let addressData = {
                            address_id: this.order_data.shippingaddressid,
                            address1: this.order_data.shippingaddress1,
                            address2: this.order_data.shippingaddress2,
                            city: this.order_data.shippingcity,
                            country: this.order_data.shippingcountry,
                            state: this.order_data.shippingaddressstate,
                            pincode: this.order_data.shippingaddresszip,
                            address_verified:
                                this.order_data.shipping_address_verified,
                            address_label:
                                this.order_data.shippingaddress_label,
                            address_type: this.order_data.shippingaddress_type,
                            first_name: this.order_data.shipping_first_name,
                            last_name: this.order_data.shipping_last_name
                        };

                        this.order_data.shipping_address_verified = 0;

                        this.verifyAddressWithUSPS(addressData)
                            .then(() => {
                                // Check if there are any suggestions - if yes, don't close modal
                                if (this.address1_suggestion || this.address2_suggestion || 
                                    this.city_suggestion || this.state_suggestion || this.pincode_suggestion) {
                                    this.$parent.isLoader = false;
                                    return; // Keep modal open so user can see and apply the suggestion
                                }

                                this.order_data.shipping_address_verified = 1;
                                this.updateAddress(addressData)
                                    .then(() => {
                                        setTimeout(() => {
                                            this.getShippingStateAndZipCode(
                                                this.order_data
                                                    .shippingaddressid,
                                                true
                                            );
                                        }, 100);
                                        if (this.order_data.sameaddress) {
                                            this.onChangeBillingAddress(
                                                this.order_data
                                                    .shippingaddressid
                                            );
                                        }
                                        if (
                                            this.order_data.billingaddressid ==
                                            this.order_data.shippingaddressid
                                        ) {
                                            this.order_data.address1 =
                                                this.order_data.shippingaddress1;
                                            this.order_data.address2 =
                                                this.order_data.shippingaddress2;
                                            this.order_data.city =
                                                this.order_data.shippingcity;
                                            this.order_data.billingcountry =
                                                this.order_data.shippingcountry;
                                            this.order_data.addressstate =
                                                this.order_data.shippingaddressstate;
                                            this.order_data.addresszip =
                                                this.order_data.shippingaddresszip;
                                            this.order_data.address_verified =
                                                this.order_data.shipping_address_verified;

                                            this.$parent.order_data.address1 =
                                                this.order_data.shippingaddress1;
                                            this.$parent.order_data.address2 =
                                                this.order_data.shippingaddress2;
                                            this.$parent.order_data.city =
                                                this.order_data.shippingcity;
                                            this.$parent.order_data.billingcountry =
                                                this.order_data.shippingcountry;
                                            this.$parent.order_data.addressstate =
                                                this.order_data.shippingaddressstate;
                                            this.$parent.order_data.addresszip =
                                                this.order_data.shippingaddresszip;
                                            this.$parent.order_data.address_verified =
                                                this.order_data.shipping_address_verified;
                                            setTimeout(() => {
                                                this.getStateAndZipCode(
                                                    this.order_data
                                                        .billingaddressid,
                                                    true
                                                );
                                            }, 100);
                                        }
                                        this.$forceUpdate();
                                        /* eslint-disable */
                                        $("#deliveryAddressModal").modal(
                                            "hide"
                                        );
                                        /* eslint-enable */
                                        this.address_type_error = "";
                                        this.$parent.isLoader = false;
                                    })
                                    .catch(() => {
                                        this.$parent.isLoader = false;
                                        this.address_type_error = "";
                                    });
                            })
                            .catch(() => {
                                this.$parent.isLoader = false;
                                this.address1_suggestion =
                                    addressData.address1_suggestion || "";
                                this.address2_suggestion =
                                    addressData.address2_suggestion || "";
                                this.city_suggestion =
                                    addressData.city_suggestion || "";
                                this.state_suggestion =
                                    addressData.state_suggestion || "";
                                this.pincode_suggestion =
                                    addressData.pincode_suggestion || "";
                                this.address_type_error = "";
                            });
                    });
            }
        },
        updateBillingAddress() {
            if (this.address_type_error == "") {
                this.resetSuggestions(this);
                this.$validator
                    .validateAll("billingaddressform")
                    .then((isValid) => {
                        if (!isValid) {
                            return;
                        }

                        this.$parent.isLoader = true;

                        let addressData = {
                            address_id: this.order_data.billingaddressid,
                            address1: this.order_data.address1,
                            address2: this.order_data.address2,
                            city: this.order_data.city,
                            country: this.order_data.billingcountry,
                            state: this.order_data.addressstate,
                            pincode: this.order_data.addresszip,
                            address_verified: this.order_data.address_verified,
                            address_type: this.order_data.address_type,
                            address_label: this.order_data.address_label,
                            first_name: this.order_data.billing_first_name,
                            last_name: this.order_data.billing_last_name
                        };

                        this.order_data.address_verified = 0;

                        this.verifyAddressWithUSPS(addressData)
                            .then(() => {
                                // Check if there are any suggestions - if yes, don't close modal
                                if (this.address1_suggestion || this.address2_suggestion || 
                                    this.city_suggestion || this.state_suggestion || this.pincode_suggestion) {
                                    this.$parent.isLoader = false;
                                    return; // Keep modal open so user can see and apply the suggestion
                                }

                                this.order_data.address_verified = 1;
                                this.updateAddress(addressData)
                                    .then(() => {
                                        setTimeout(() => {
                                            this.getStateAndZipCode(
                                                this.order_data
                                                    .billingaddressid,
                                                true
                                            );
                                        }, 100);
                                        if (this.order_data.sameaddress) {
                                            this.onChangeDeliveryAddress(
                                                this.order_data.billingaddressid
                                            );
                                        }
                                        if (
                                            this.order_data.billingaddressid ==
                                            this.order_data.shippingaddressid
                                        ) {
                                            this.order_data.shippingaddress1 =
                                                this.order_data.address1;
                                            this.order_data.shippingaddress2 =
                                                this.order_data.address2;
                                            this.order_data.shippingcity =
                                                this.order_data.city;
                                            this.order_data.shippingcountry =
                                                this.order_data.billingcountry;
                                            this.order_data.shippingaddressstate =
                                                this.order_data.addressstate;
                                            this.order_data.shippingaddresszip =
                                                this.order_data.addresszip;
                                            this.order_data.shipping_address_verified =
                                                this.order_data.address_verified;

                                            this.$parent.order_data.shippingaddress1 =
                                                this.order_data.address1;
                                            this.$parent.order_data.shippingaddress2 =
                                                this.order_data.address2;
                                            this.$parent.order_data.shippingcity =
                                                this.order_data.city;
                                            this.$parent.order_data.shippingcountry =
                                                this.order_data.billingcountry;
                                            this.$parent.order_data.shippingaddressstate =
                                                this.order_data.addressstate;
                                            this.$parent.order_data.shippingaddresszip =
                                                this.order_data.addresszip;
                                            this.$parent.order_data.shipping_address_verified =
                                                this.order_data.address_verified;
                                            console.log(
                                                "billing complete address1"
                                            );
                                            setTimeout(() => {
                                                this.getShippingStateAndZipCode(
                                                    this.order_data
                                                        .shippingaddressid,
                                                    true
                                                );
                                            }, 100);

                                            console.log(
                                                "billing complete address"
                                            );
                                        }
                                        this.$forceUpdate();
                                        /* eslint-disable */
                                        $("#billingAddressModal").modal("hide");
                                        /* eslint-enable */
                                        this.$parent.isLoader = false;
                                        this.address_type_error = "";
                                    })
                                    .catch(() => {
                                        this.$parent.isLoader = false;
                                        this.address_type_error = "";
                                    });
                            })
                            .catch(() => {
                                this.$parent.isLoader = false;
                                this.address1_suggestion =
                                    addressData.address1_suggestion || "";
                                this.address2_suggestion =
                                    addressData.address2_suggestion || "";
                                this.city_suggestion =
                                    addressData.city_suggestion || "";
                                this.state_suggestion =
                                    addressData.state_suggestion || "";
                                this.pincode_suggestion =
                                    addressData.pincode_suggestion || "";
                                this.address_type_error = "";
                            });
                    });
            }
        },
        addShippingAndPaymentDetail() {
            if (this.$store.state.splitShipment.isSplitShipment === false) {
                this.$store.commit('splitShipment/resetSplitShipment');
            }
            var _this = this;
            _this.order_data.cardexpiredate =
                _this.order_data.cardexpiremonth +
                "/" +
                _this.order_data.cardexpireyear;
            // alert(_this.order_data.cardexpiredate)
            _this.$validator
                .validateAll("shippingandpaymentform")
                .then(async (isValid) => {
                    if (isValid) {
                        _this.$parent.isLoader = true;

                        let fullbillingaddress =
                            _this.order_data.address1 +
                            " " +
                            _this.order_data.address2;
                        let fullshippingaddress =
                            _this.order_data.shippingaddress1 +
                            " " +
                            _this.order_data.shippingaddress2;
                        if (_this.$parent.netsuite_customer_data) {
                            _this.$parent.netsuite_customer_data.addressBook.items.forEach(
                                (address) => {
                                    if (
                                        address.addressBookAddress.addr1 ==
                                        fullbillingaddress.trim()
                                    ) {
                                        _this.order_data.billing_address_internal_id =
                                            address.internalId;
                                    }
                                    if (
                                        address.addressBookAddress.addr1 ==
                                        fullshippingaddress.trim()
                                    ) {
                                        _this.order_data.shipping_address_internal_id =
                                            address.internalId;
                                    }
                                }
                            );
                        }

                        if (_this.order_data.sameaddress) {
                            _this.order_data.shipping_address_internal_id =
                                _this.order_data.billing_address_internal_id;
                        }

                        let netsuite_customer;
                        let address_data = {};
                        if (!_this.order_data.billing_address_internal_id) {
                            address_data = {
                                billing_address: {
                                    phone: _this.order_data.phone,
                                    email: _this.order_data.email,
                                    address1: _this.order_data.address1,
                                    address2: _this.order_data.address2,
                                    city: _this.order_data.city,
                                    state: _this.order_data.addressstate,
                                    country: _this.order_data.billingcountry,
                                    zip: _this.order_data.addresszip
                                }
                            };
                        }

                        if (!_this.order_data.shipping_address_internal_id) {
                            address_data["shipping_address"] = {
                                phone: _this.order_data.phone,
                                email: _this.order_data.email,
                                address1: _this.order_data.shippingaddress1,
                                address2: _this.order_data.shippingaddress2,
                                city: _this.order_data.shippingcity,
                                state: _this.order_data.shippingaddressstate,
                                country: _this.order_data.shippingcountry,
                                zip: _this.order_data.shippingaddresszip
                            };
                        }

                        if (
                            address_data.billing_address ||
                            address_data.shipping_address
                        ) {
                            netsuite_customer =
                                await this.$parent.updateCustomerInNetsuite(
                                    _this.order_data.sameaddress,
                                    address_data
                                );
                        }

                        if (netsuite_customer) {
                            netsuite_customer.addressBook.items.forEach(
                                (address) => {
                                    if (
                                        address.addressBookAddress.addr1 ==
                                        fullbillingaddress.trim()
                                    ) {
                                        _this.order_data.billing_address_internal_id =
                                            address.internalId;
                                    }
                                    if (
                                        address.addressBookAddress.addr1 ==
                                        fullshippingaddress.trim()
                                    ) {
                                        _this.order_data.shipping_address_internal_id =
                                            address.internalId;
                                    }
                                }
                            );

                            if (_this.order_data.sameaddress) {
                                _this.order_data.shipping_address_internal_id =
                                    _this.order_data.billing_address_internal_id;
                            }
                        }

                        _this.order_data.total_non_standard_fees =
                            _this.$parent.order_data.total_non_standard_fees;

                        // Add shipping_option to order_data
                        _this.order_data.shipping_option =
                            _this.shipping_option;

                        // Reset payment methods before assigning to parent (user should select manually)
                        _this.order_data.is_pay_later = false;
                        _this.order_data.is_payvia_terms = 0;
                        _this.order_data.is_pay_way_terms = false;
                        _this.order_data.is_cod = false;
                        _this.order_data.is_saved_card = false;
                        _this.order_data.customerPaymentProfileId = "";

                        // var _this = this;
                        _this.$parent.order_data = _this.order_data;
                        _this.$parent.is_reviewpay = false;
                        _this.$parent.is_payment = true;
                        _this.$parent.isLoader = false;

                        // Removed auto-select card - let user select payment method manually
                        // _this.$emit("selectDefaultCard");
                        /* eslint-disable */
                        $("html,body").animate(
                            {
                                scrollTop: 0
                            },
                            "slow"
                        );
                        /* eslint-enable */
                    } else {
                        _this.$parent.isLoader = false;
                    }
                });
        },

        getSalesTax(zip) {
            return new Promise((resolve, reject) => {
                ApiService.get(`/sale-tax-by-zip/${zip}`)
                    .then(({ data }) => {
                        if (data.sale_tax) {
                            // Calculate base amount for tax: grand_total - current_sales_tax
                            // This gives us subtotal + shipping (without sales tax)
                            const currentSalesTax = parseFloat(this.$parent.order_data.sales_tax || 0);
                            const baseAmount = parseFloat(this.$parent.order_data.grand_total || 0) - currentSalesTax;
                            
                            this.order_data.sales_tax = parseFloat(
                                baseAmount *
                                    data.sale_tax.estimated_combined_rate
                            ).toFixed(2);
                            this.$parent.order_data.sales_tax = parseFloat(
                                parseFloat(this.order_data.sales_tax).toFixed(2)
                            );
                            /*  this.$parent.order_data.order_price += parseFloat(
                                this.$parent.order_data.sales_tax
                            ); */
                        } else {
                            this.order_data.sales_tax = 0;
                            this.$parent.order_data.sales_tax = 0;
                        }
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },

        storeTempData() {
            this.temp_order = JSON.parse(JSON.stringify(this.order_data));
        },

        restoreTempData() {
            this.resetSuggestions(this);
            this.order_data = JSON.parse(JSON.stringify(this.temp_order));
            this.temp_order = null;
            this.address_type_error = "";
        }
    },
    watch: {
        shipping_option: {
            handler(newVal, oldVal) {
                if (newVal === 'multiple') {
                    this.$store.commit('splitShipment/setSplitShipment', true);
                    this.$parent.split_shipment_step = 'addresses';
                    return;
                }
                if (newVal !== oldVal && this.$parent) {
                    var _this = this;
                    // Update parent's order_data and shipping_option
                    if (this.$parent.order_data) {
                        this.$parent.order_data.shipping_option = newVal;
                        this.order_data.shipping_option = newVal;
                    }
                    if (
                        newVal === "pickup_warehouse" ||
                        newVal === "delivery"
                    ) {
                        this.clearShippingAddressSelection();
                    } else if (
                        newVal === "ship_to_address" &&
                        (oldVal === "pickup_warehouse" ||
                            oldVal === "delivery")
                    ) {
                        this.$nextTick(() => {
                            this.restoreShipToAddressSameAsBilling();
                        });
                    }
                    if (this.$parent.shipping_option !== undefined) {
                        this.$parent.shipping_option = newVal;
                    }
                    
                    // If shipping provider is already selected, trigger API call again
                    // This ensures shipping methods are refreshed when option changes
                    if (_this.order_data.shippingproviderid && _this.shippingCarriers.length > 0) {
                        const selectedCarrier = _this.shippingCarriers.find(
                            carrier => carrier.id == _this.order_data.shippingproviderid
                        );
                        if (selectedCarrier) {
                            // Check if address is available (required for ship_to_address)
                            if (newVal === "ship_to_address") {
                                // For ship_to_address, address must be set
                                if (_this.order_data.shippingaddressid && _this.order_data.billingaddressid) {
                                    // Address is set, trigger API call
                                    _this.$nextTick(() => {
                                        _this.getShippingProviderImage(
                                            _this.order_data.shippingproviderid,
                                            selectedCarrier.shpping_provider
                                        );
                                    });
                                }
                            } else {
                                // For pickup_warehouse or delivery, address is not required
                                _this.$nextTick(() => {
                                    _this.applyPickupDeliveryStaticShipping();
                                });
                            }
                        }
                    }
                    
                    // Call onShippingCarrierChange in PaymentShipmentV2 component (sibling component)
                    // Both ShippingPayment and PaymentShipmentV2 are children of Checkout.vue
                    if (this.$parent.$children) {
                        // Find PaymentShipmentV2 component in parent's children (sibling)
                        const paymentShipmentV2 = this.$parent.$children.find(
                            child => child.$options && child.$options.name === 'PaymentShipmentV2'
                        );
                        if (paymentShipmentV2 && typeof paymentShipmentV2.onShippingCarrierChange === 'function') {
                            // Only call if shipping provider is already selected
                            if (paymentShipmentV2.order_data && paymentShipmentV2.order_data.shippingproviderid) {
                                paymentShipmentV2.onShippingCarrierChange();
                            }
                        }
                    }
                }
            },
            // Sync parent order_data on load so Review & Pay / siblings see correct option without a radio toggle
            immediate: true
        }
    }
};
</script>
<style>
.removeDisableIcon {
    pointer-events: none !important;
}

.edit-button {
    margin-top: 15px;
}
.shipping_payment_detail .white_box textarea.form-control {
    overflow: hidden;
    padding: 0px 0px 0px 3px !important;
    height: 30px !important;
}
.shipping_payment_detail .white_box label.add1 {
    margin-bottom: 3px !important;
}
.shipping_payment_detail .white_box .select_option_label{
    font-weight: 400 !important;
    margin-top: 0px !important;
    color: #000000;
    font-size: 14px;
    line-height: 21px;
}

.shipping_payment_detail .white_box .choose_address .select_option_label{
    position: relative;
    top: 0px !important;
}
.shipping_payment_detail .white_box .billing_address_title{
    margin-bottom: 20px !important;
}
.shipping_payment_detail .shipping_billing_address_col .shipping_fl_left .heading1{
    color: #121212;
    line-height: 24px;
}
.shipping_payment_detail .shipping_billing_address_col .checkbox_custom .checkmark:after{
    top: -1px !important;
}
.shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .new-address-popup .modal-content .modal-footer .cancel-address {
    font-size: 15px;
    padding: 15px 20px !important;
}
.shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .new-address-popup .modal-content .modal-footer .save-address {
    font-size: 15px;
    padding: 15px 30px !important;
}
.shipping_payment_detail .white_box .two_input_one_row .form-group {
    width: 100% !important;
    margin: 0px;
    max-width: 50%;
}
.shipping_payment_detail .white_box .two_input_one_row{
    gap: 20px
}
.shipping_payment_detail .address-form-section {
    border: 1px solid #B6B6B6 !important;
    padding: 16px !important;
    background: #fff;
    border-radius: 4px;
}

.shipping_payment_detail .address-form-section .form-control {
    border: 1px solid #33333380 !important;
    height: 40px !important;
    font-weight: 600 !important;
}

.shipping_payment_detail .address-new-form-section label {
    font-size: 14px;
    line-height: 14px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 12px;
        top: 0px !important;
    position: relative;
}
 .label-required-mark {
    color: #FF3B30;
}
/* .shipping_payment_detail .text-info {
    color: #ff0000 !important;
} */
.shipping_payment_detail .shipping_save{
    min-width: 130px !important;
    height: 40px !important;
    padding: 0 20px !important;
    border-radius: 4px !important;
    font-size: 16px !important;
    line-height: 20px !important;
    font-weight: 600 !important;
    letter-spacing: 0.04em !important;
    text-transform: uppercase !important;
    border: none !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.shipping_payment_detail .shipping_cancel{
    min-width: 130px;
    height: 40px;
    padding: 0 20px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
}
.shipping_payment_detail .border_primary_blue{
    border-color: #1d6cb5 !important;
    height: 40px !important;
    border-radius: 4px !important;
    border: 1px solid #1D6CB5 !important;
    max-width: 120px !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #1D6CB5 !important;
    font-weight: 600 !important;
    font-family: 'mulish';
}
.shipping_payment_detail button.btn.btn_orange.bg_primary_orange {
    width: auto !important;
    max-width: none !important;
    height: 48px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
}
section.shipping_payment_detail .white_box .address-form-section .address_type .vs__selected-options input{
background-position: 98% 52% !important;
}
section.shipping_payment_detail .choose_address .vs__selected-options input{
            background-position: 99% 73% !important;
                height: 34px;
    padding: 0px !important;
}
.shipping_payment_detail .shipping_fl_left .choose_address .vs__selected-options .vs__selected{
        top: 0px;
}
.shipping_payment_detail .font_change{
font-weight: 600 !important;
font-family: 'mulish'
}
.shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .form-group.comment_label_block{
    margin-top: 28px !important;
}
.shipping_payment_detail .comment_label_block .comment-label{
        position: relative;
        margin-bottom: 0px !important;
        top: 0px !important;
}

@media (max-width: 991px) {
    .shipping_payment_detail .shipping_billing_address_col {
        padding-right: 0 !important;
    }

    .shipping_payment_detail .shipping_billing_address_col .white_box {
        padding: 32px 24px !important;
    }

    .shipping_payment_detail .shipping_billing_address_col .shipping_fl_left .heading1 {
        font-size: 24px;
        line-height: 32px;
    }

    .shipping_payment_detail .shipping-options-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 12px 20px;
    }

    .shipping_payment_detail .shipping-options-radio-group .shipping-option-label {
        margin-bottom: 0;
    }

    .shipping_payment_detail .white_box .two_input_one_row {
        gap: 16px;
    }

    .shipping_payment_detail .shipping_fl_left .address-shipping-popup .new-address-popup .modal-dialog {
        max-width: calc(100% - 32px);
        margin: 16px auto;
    }
}

@media (max-width: 767px) {
    .shipping_payment_detail .shipping_billing_address_col .white_box {
        padding: 24px 16px !important;
    }

    .shipping_payment_detail .shipping_billing_address_col .shipping_fl_left .heading1 {
        font-size: 22px;
        line-height: 30px;
    }

    .shipping_payment_detail .shipping-options-radio-group {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .shipping_payment_detail .white_box .two_input_one_row {
        flex-direction: column;
        gap: 10px;
    }

    .shipping_payment_detail .white_box .two_input_one_row .form-group {
        max-width: 100%;
    }

    .shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .new-address-popup .modal-content .modal-footer {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 10px;
    }

    .shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .new-address-popup .modal-content .modal-footer .cancel-address,
    .shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .new-address-popup .modal-content .modal-footer .save-address {
        margin: 0 !important;
    }
}

@media (max-width: 575px) {
    .shipping_payment_detail .shipping_billing_address_col .white_box {
        padding: 20px 12px !important;
    }

    .shipping_payment_detail .shipping_billing_address_col .shipping_fl_left .heading1 {
        font-size: 20px;
        line-height: 28px;
    }

    .shipping_payment_detail .shipping-options-title {
        font-size: 18px;
        line-height: 24px;
    }

    .shipping_payment_detail .shipping-options-radio-group .shipping-option-label .radio-text,
    .shipping_payment_detail .shipping-options-radio-group .shipping-option-label {
        font-size: 14px;
        line-height: 20px;
    }

    .shipping_payment_detail .shipping_save,
    .shipping_payment_detail .shipping_cancel {
        min-width: 110px !important;
        font-size: 14px !important;
    }

    .shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .new-address-popup .modal-dialog {
        max-width: calc(100% - 16px);
        margin: 8px auto;
    }

    .shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .new-address-popup .modal-content .modal-footer {
        justify-content: stretch;
    }

    .shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .new-address-popup .modal-content .modal-footer .cancel-address,
    .shipping_payment_detail .shipping_fl_left .f_fl_left.shipping_address_form_custom.address-shipping-popup .new-address-popup .modal-content .modal-footer .save-address {
        width: 100%;
    }
}
</style>
